import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Skeleton, Tooltip } from "@mui/material";
import DateConverter from "@heartinz/date_and_time_processor";
import {
  LoadScript,
  GoogleMap,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import uRLs from "../../../utils/baseUtils";
import { CircularProgress } from "@mui/material";
import handleError from "../../../constant/handleError";
import axiosInstance, { axiosInstance2 } from "../../../utils/AxiosInstance";
import useShowAlert from "../../../utils/AlertUtiles";
import PaymentHistory from "./PaymentHistory";
import { capitalize, capitalizeFirstLetter, resizeImage, getSubBookingStatusLabel } from "../../../utils/helper";
import PaymentForm from "./PaymentForm";
import AssignGangLeader from "./AssignGangLeader";
import AssignGangLeaderBatch from "./AssignGangLeaderBatch";
import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import CancelBooking from "./CancelBooking";
import AssignFieldOfficer from "./AssignFieldOfficer";
import UploadWorkModal from "./UploadWorkModal";
import AdminBookingTimeline from "./AdminBookingTimeline";
import { canAllocateGangLeaders } from "./glAllocation";
import { NURSERY_DISTANCE_LABELS, formatNurseryAge, formatNurseryDistance, todayIsoDate } from "./nurseryAssessment";

const Viewbooking = ({
  onClose = () => {},
  isSelectedData,
  setSelectedData,
  onApprove,
  loading,  
  setLoading,
  setBooking,
  handleOpen,
  isModelClose,
  isOpen,
  setTotalItems,
  activeStatus,
  handleViewBooking
    
}) => {
  const [isPreLoading, setPreLoading] = useState(true);
  const [assignModal, setAssignModal] = useState({
  gangLeader: false,
  fieldOfficer: false,
  gangLeaderBatch: false,
});
  const [errors, setErrors] = useState(false);
  const [showAssignOptions, setShowAssignOptions] = useState(false);
  const [dimensionList,setDimensionList]=useState([]);
  const [selectedDimension, setSelectedDimension] = useState("");
  const [activeView, setActiveView] = useState("status");
  const [isEditingWorkDate, setIsEditingWorkDate] = useState(false);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [isPayment, setPayment] = useState([]);
  const [openWorkImageModal, setOpenWorkImageModal] = useState(false);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const showAlert = useShowAlert(); 
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [completeModalSubBookings, setCompleteModalSubBookings] = useState([]);
  const [loadingCompleteModalSubBookings, setLoadingCompleteModalSubBookings] = useState(false);
  const [measurement, setMeasurement] = useState(isSelectedData.numberOfAcres);
  const [openMeasurementModal, setOpenMeasurementModal] = useState(false);
  const [openFOAssessment, setOpenFOAssessment] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    mobileNumber: "",
    credibility: "",
    finalImage:"",
    workImages: [],
    workImagePreviews: [],
    latitude: "",
    longitude: "",
    singleImage:"",
     location:"",
    stones: "",
    nurseryDate: "",
    nurseryField: "",
    nurseryDistance: "",
    waterAvailable: "",
    fanAvailable: "",
    stayToFieldDistanceInKm: "",
    farmerProvidesVehicle: "",
    accommodationFrontPhoto: null,
    accommodationInsidePhoto: null,
  });
  const [dimensionDecisionLoading, setDimensionDecisionLoading] = useState(false);
  const [showDimensionRejectInput, setShowDimensionRejectInput] = useState(false);
  const [dimensionRejectReason, setDimensionRejectReason] = useState("");
const isSameMeasurement =
  Number(measurement) === Number(isSelectedData?.numberOfAcres);
  const saveButtonRef = useRef(null);
  const nameRef = useRef(null);
  const phoneRef = useRef(null);
  const DimensionRef = useRef(null);
  const clickLockRef = useRef(null);
  const ImagesRef = useRef(null);
  const WorkImagesRef = useRef(null);

const latestMeasurement =
  isSelectedData?.measurementStatus?.[
    isSelectedData?.measurementStatus?.length - 1
  ];

  const lastWorkImage =
  isSelectedData?.workImages?.[
    isSelectedData?.workImages?.length - 1
  ];
  const [isEditablePerAcres, setEditablePerAcres] = useState(
    isSelectedData?.perAcreCost || 0
  );
  const [isEditableNmberOfAcres, setEditableNmberOfAcres] = useState(
    isSelectedData?.numberOfAcres || 0
  );
  const [isEditableWorkDate, setEditableWorkDate] = useState(
    isSelectedData?.workStartDate ? DateConverter.ISOToDisplayFormat(
      DateConverter.convertToTimeZone(
        isSelectedData.workStartDate,
        uRLs.TIMEZONE
      )
    ).date : "" 
  );
   const [longitude, latitude] = isSelectedData.location.coordinates;
  var position = {
  lat: latitude,
  lng: longitude
};
  // var position = {
  //   lat: isSelectedData.location.coordinates[0],
  //   lng: isSelectedData.location.coordinates[1],
  // };
 
 const handleOpenCancelBooking = () => {
  setShowCancelModal(true);
};
const handleCloseCancelBooking = () => {
  setShowCancelModal(false);
};
  const mapContainerStyle = {
    width: "100%",
    height: "200px",
    borderRadius: "4px",
  };

  useEffect(() => {
    if (isSelectedData?.perAcreCost) {
      setEditablePerAcres(isSelectedData.perAcreCost);
    }
    setPreLoading(false);
  }, [isSelectedData]);

  const [parentBookingSummary, setParentBookingSummary] = useState(null);
  useEffect(() => {
    if (isSelectedData?.isPrimaryBooking === false && isSelectedData?.parentBookingId) {
      let cancelled = false;
      axiosInstance
        .get(`farmerbooking/admin/details/${isSelectedData.parentBookingId}`)
        .then((response) => {
          if (!cancelled && response?.data?.status) {
            setParentBookingSummary(response.data.results);
          }
        })
        .catch(() => {});
      return () => {
        cancelled = true;
      };
    }
    setParentBookingSummary(null);
  }, [isSelectedData?.isPrimaryBooking, isSelectedData?.parentBookingId]);

  // Split-aware completion: a split booking's measurement and work completion
  // live on its Gang Leader sub-bookings, so fetch them when the booking opens
  // (to decide whether it can be completed) and again when the completion
  // modal opens (so its checklist is current).
  useEffect(() => {
    if (!isSelectedData?.supportsSplit || !isSelectedData?._id) {
      setCompleteModalSubBookings([]);
      return;
    }
    let cancelled = false;
    setLoadingCompleteModalSubBookings(true);
    axiosInstance
      .get(`farmerbooking/admin/${isSelectedData._id}/batch/sub-bookings`)
      .then((response) => {
        if (!cancelled && response?.data?.status) {
          setCompleteModalSubBookings(response.data.results || []);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoadingCompleteModalSubBookings(false);
      });
    return () => {
      cancelled = true;
    };
  }, [showCompleteModal, isSelectedData?.supportsSplit, isSelectedData?._id]);

   useEffect(() => {
    
    if(openFOAssessment){
     nameRef.current.focus();
    }
  }, [openFOAssessment]);
  const handleUpdateAmount = async () => {
    const newAmount = parseFloat(isEditablePerAcres);
    const acres = parseFloat(isSelectedData?.numberOfAcres || 0);
    const paidAmount = parseFloat(isSelectedData?.totalPaid || 0);    
    const expectedTotalAmount = newAmount * acres;      
    if (isNaN(newAmount) || newAmount <= 0) {
      setErrors({
        perAcreCost: "Please enter a valid amount (number greater than 0).",
      });
      return;
    } else if (expectedTotalAmount < paidAmount) { 
    setErrors({
      perAcreCost: `The total amount should be greater than the paid amount.`,
    }); 
    return;
  }
    setErrors({});
    setLoading((prev) => ({ ...prev, upadteBooking: true }));
    try {
      const data = {
        pricePerAcre: newAmount,
      };
      const response = await axiosInstance.patch(
        `farmerbooking/admin/amount/${isSelectedData._id}`,
        data
      );
      if (
        response &&
        response?.data?.status &&
        response?.data?.results
      ) {
        showAlert("success", response?.data?.message);
        const updatedBooking = response.data.results;
        isSelectedData.pricePerAcre = newAmount;
        setEditablePerAcres(newAmount);
        setBooking((prevBookings) => {       
        return prevBookings.map((booking) => {        
          if (booking._id === isSelectedData._id) {           
            return {
              ...booking,
              perAcreCost: updatedBooking.perAcreCost,
              totalAmount: updatedBooking.totalAmount, 
            };
          }
          return booking; 
        });
      });
        setSelectedData((prevSelected) => ({
          ...prevSelected,
          perAcreCost: updatedBooking.perAcreCost,
          totalAmount: updatedBooking.totalAmount, 
          balanceAmount:updatedBooking.balanceAmount
        }));
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, upadteBooking: false }));
    }
  };
 const handleUpdateAcres = async () => {
    const newAmount = parseFloat(isEditableNmberOfAcres);
    const price = parseFloat(isSelectedData?.perAcreCost || 0);
    const paidAmount = parseFloat(isSelectedData?.totalPaid || 0);       
    const expectedTotalAmount = newAmount * price;
       
    if (isNaN(newAmount) || newAmount <= 0) {
      setErrors({
        numberOfAcres: "Please enter a valid amount (number greater than 0).",
      });
      return;
    }else if (newAmount < 2) {
    setErrors({
      numberOfAcres: "Minimum number of acres should be 2.",
    });
    return;
  }  if (expectedTotalAmount < paidAmount) {
    setErrors({
      numberOfAcres: "Total amount should be greater than the paid amount.",
    });
    return;
  }

    setErrors({});
    setLoading((prev) => ({ ...prev, upadteNoOfAcres: true }));
    try {
      const data = {
        numberOfAcres: newAmount,
      };
      const response = await axiosInstance.patch(
        `/farmerbooking/admin/acre/${isSelectedData._id}`,
        data
      );
      if (
        response &&
        response?.data?.status &&
        response?.data?.results
      ) {
        showAlert("success", response?.data?.message);
        const updatedBooking = response.data.results;
        isSelectedData.numberOfAcres = newAmount;
        setEditableNmberOfAcres(newAmount);
        setBooking((prevBookings) => {       
        return prevBookings.map((booking) => {        
          if (booking._id === isSelectedData._id) {           
            return {
              ...booking,
              numberOfAcres:updatedBooking.numberOfAcres,
              perAcreCost: updatedBooking.perAcreCost,
              totalAmount: updatedBooking.totalAmount, 
            };
          }
          return booking; 
        });
      });
        setSelectedData((prevSelected) => ({
          ...prevSelected,
          perAcreCost: updatedBooking.perAcreCost,
          totalAmount: updatedBooking.totalAmount, 
          balanceAmount:updatedBooking.balanceAmount
        }));
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, upadteNoOfAcres: false }));
    }
  };
const handleBookingConfirm = async (selctedID) => {  
    setLoading((prev) => ({ ...prev, confirmBooking: true }));
    try {
    
      const response = await axiosInstance.patch(
        `/farmerbooking/admin/confirm/${isSelectedData._id}`        
      );
      if (
        response &&
        response?.data?.status &&
        response?.data?.results
      ) {
        showAlert("success", response?.data?.message);
        const updatedBooking = response.data.results;
       setSelectedData((prevSelected) => {
        const updatedHistory = [...(prevSelected?.bookingStatusHistory || [])];
        
        
        const hasConfirmed = updatedHistory.some(
          (s) => s.bookingTracking === updatedBooking.lastStatus        );
        
        if (!hasConfirmed) {
          updatedHistory.push({
            _id: updatedBooking._id,
            bookingTracking: updatedBooking.lastStatus, // e.g., "BOOKINGCOMPLETED"
            entryBy: updatedBooking.lastUpdatedBy || "OWNER",
            time: updatedBooking.updatedAt, 
            
          });
        }

        return {
          ...prevSelected,
          ...updatedBooking, // Spread the updated API results directly to sync all root level changes (bookingStatus, workStatus, etc.)
          bookingStatusHistory: updatedHistory,
          time: updatedBooking.updatedAt,
        };
      });
     
  //         setSelectedData((prevSelected) => {
  //   const updatedHistory = [...(prevSelected?.bookingStatusHistory || [])];
    
  //   const hasConfirmed = updatedHistory.some(s => s.bookingTracking === "updatedBooking.lastStatus");
    
  //   if (!hasConfirmed) {
  //     updatedHistory.push({
  //       _id: updatedBooking._id,
  //       bookingTracking: updatedBooking.lastStatus,
  //       entryBy: updatedBooking.lastUpdatedBy,
  //       time: updatedBooking.updatedAt, // This instantly populates the timeline's clock
       
  //     });
  //   }

  //   return {
  //     ...prevSelected,
  //     lastStatus: updatedBooking.lastStatus,
  //     bookingStatusHistory: updatedHistory,
  //     bookingStatus:updatedBooking.bookingStatus,
  //     workStatus:updatedBooking.workStatus
  //   };
  // });
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, confirmBooking: false }));
    }
  };



  const handleBookingComplete = async (selctedID) => {  
    setLoading((prev) => ({ ...prev, bookingComplete: true }));
    try {
    
      const response = await axiosInstance.patch(
        `/farmerbooking/admin/completed/${isSelectedData._id}`        
      );
      if (
        response &&
        response?.data?.status &&
        response?.data?.results
      ) {
        showAlert("success", response?.data?.message);
        const updatedBooking = response.data.results;
       setShowCompleteModal();
     
  //         setSelectedData((prevSelected) => {  
  //   return {
  //     ...prevSelected,
  //     lastStatus: updatedBooking.lastStatus,
  //    bookingStatus:updatedBooking.bookingStatus
  //   };
  // });
 setSelectedData((prevSelected) => {    
  const updatedHistory = [...(prevSelected?.bookingStatusHistory || [])];
  const hasCompletedStep = updatedHistory.some(
    (s) => s.bookingTracking === updatedBooking.lastStatus
  );   
  if (!hasCompletedStep) {
    updatedHistory.push({
      _id: updatedBooking._id || prevSelected?._id,
      bookingTracking: updatedBooking.lastStatus || "BOOKINGCOMPLETED", 
      entryBy: updatedBooking.lastUpdatedBy || "OWNER",
      time: updatedBooking.updatedAt || new Date().toISOString(), 
    });
  }
  return {
    ...prevSelected, 
    lastStatus: updatedBooking.lastStatus || "BOOKINGCOMPLETED",
    bookingStatus: updatedBooking.bookingStatus || "COMPLETED",
    bookingStatusHistory: updatedHistory 
  };
});
}
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, bookingComplete: false }));
    }
  };
  const handleOpenPayment = () => {
    setActiveView("payment");
  };
  const handleClose = () => {
    setActiveView("status");   
  };

  const DetailItem = ({ iconClass, title, value ,col}) => {
    return (
      <div className={col ? col : "col-lg-4 col-md-6"}>
        <div className="p-1">
          <div className="d-flex align-items-start gap-2 p-2 rounded">
            <div className="detail-icon fs-5 text-primary">
              <i className={`bx ${iconClass} font-24`}></i>
            </div>
            <div className="detail-info">
              <h6 className="fw-bold text-muted mb-1">{title}</h6>
              <p className="mb-0 fw-bold text-dark">{value}</p>
            </div>
          </div>
        </div>
      </div>
    );
  };


  const AddPayment = async (payData) => {    
    setLoading((prev) => ({ ...prev, addPayment: true }));   
    try {
  const convertToISO = () => {
  const { transactionDateTime, timeHour, timeMinute, timePeriod } = payData;

  if (!transactionDateTime || !timeHour || !timeMinute || !timePeriod) {
    return null;
  }

  let hour = parseInt(timeHour, 10);
  const minute = parseInt(timeMinute, 10);

  // Convert to 24-hr:
  if (timePeriod === "PM" && hour !== 12) hour += 12;
  if (timePeriod === "AM" && hour === 12) hour = 0;

  const combined = `${transactionDateTime} ${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}:00`;

  return dayjs(combined).toISOString();
};
    const isoDate = convertToISO();  

    if (!isoDate) {
      showAlert("error", "Please enter valid date and time");
      return;
    }

    const formattedDate = DateConverter.convertToTimeZone(
      isoDate,
      uRLs.TIMEZONE
    );
  
      const data = {
        bookingId: isSelectedData?._id,
        paidAmount:Number(payData?.amount ||0),       
        notes:payData.notes,
        paymentMethod:payData?.paymentMode,       
        transactionId:payData?.transactionID,
        transactionDateTime:formattedDate
      }; 
      const response = await axiosInstance.patch(
        `farmerbooking/admin/payment-registration`,
        data
      );
      if (
        response &&
        response?.data?.status &&
        response?.data?.results
      ) {
        showAlert("success", response?.data?.message);
        const { bookingData, statusHistoryData } = response.data.results;   
        setSelectedData((prevSelected) => ({
          ...prevSelected,          
          totalPaid: bookingData?.totalPaid,
          balanceAmount: bookingData?.balanceAmount,        
          bookingStatusHistory: [
            ...(prevSelected.bookingStatusHistory || []), 
            {           
              bookingTracking: statusHistoryData.bookingTracking,
              paymentMode:statusHistoryData?.paymentMode,
              paymentStatus:statusHistoryData?.paymentStatus,
              amount: statusHistoryData?.amount, 
              entryBy: statusHistoryData?.entryBy, 
              time: statusHistoryData?.time , 
              accountHolderName:statusHistoryData?.accountHolderName, 
              notes:statusHistoryData?.notes, 
              instruction:statusHistoryData?.instruction, 
              paymentMethod:statusHistoryData?.paymentMethod, 

            },
          ],
        }));  
        setPayment((prevList) => [
        ...(prevList || []), 
        statusHistoryData 
    ]);
        setBooking((prevBookings) => {
          return prevBookings.map((booking) => {
            if (booking._id === isSelectedData._id) {
              return {
                ...booking,
                totalPaid: bookingData.totalPaid,
                balanceAmount: bookingData.balanceAmount,
                lastStatus: bookingData.lastStatus, 
              };
            }
            return booking;
          });
        });
        isModelClose();
    }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, addPayment: false }));
    }
  };
  
  const LongDetailItem = ({ title, value }) => {
    return (
      <div className="col-12 mt-1">
        <div className="p-2 border rounded">
          <h6 className="fw-bold text-primary mb-1">{title}</h6>
          <p className="mb-0 text-dark" style={{ whiteSpace: "pre-wrap" }}>
            {value}
          </p>
        </div>
      </div>
    );
  };

  const CheckboxDetailItem = ({ title, isChecked }) => {
    return (
      <div className="col-lg-4 col-md-6">
        <div className="p-1">
          <div className="d-flex align-items-center gap-2 p-2 rounded">
            <i
              className={`bx font-24 ${
                isChecked
                  ? "bx-check-circle text-primary"
                  : "bx-x-circle text-danger"
              } fs-4`}
            ></i>

            <div>
              <h6 className="fw-bold text-muted mb-1">{title}</h6>

              <p className="text-dark mb-0 fw-bold font-14">
                {isChecked
                  ? "Stay arrangement provided"
                  : "Stay arrangement not provided"}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

const getStatusDisplayDetails = (s, currentIndex, history) => {
    const lastIndex = history.length - 1;
    let color = "#28a745";
    let currentStatusClass = "border-success";
    let icon = "bx-check";
    let statusDisplay = s.bookingTracking;
   if (s.bookingTracking === "ADVANCEPENDING") {
        color = "#ffc107";
        currentStatusClass = "border-warning";
        icon = "bx-time-five";
        statusDisplay = "Advance Pending";
    }

    // ADVANCE PAID
    else if (s.bookingTracking === "ADVANCEPAID") {
        color = "#28a745";
        currentStatusClass = "border-success";
        icon = "bx-check";
        statusDisplay = "Advance Payment Completed";
    }
     if (s.bookingTracking === "GLMEASUREMENTPENDING") {
        color = "#ffc107";
        currentStatusClass = "border-warning";
        icon = "bx-time-five";
        statusDisplay = "Captain Measurement Pending";
    }

  
    if (s.bookingTracking === "PAYMENT") {
        if (s.paymentCompleted === true || s.paymentStatus === "PAID")  {
            statusDisplay = "PAYMENT COMPLETED";
        } else {          
            if (s.paymentStatus === "FAILED" || s.paymentStatus === "REJECTED") {
                if (currentIndex !== lastIndex) {
                    statusDisplay = s.paymentStatus;
                    color = "#28a745"; 
                    currentStatusClass = "border-success";
                    icon = "bx-check";  
                } else {                 
                    statusDisplay = s.paymentStatus;
                    color = "#dc3545"; 
                    currentStatusClass = "border-danger";
                    icon = "bx-x"; 
                }

            } else {             
                statusDisplay = "PAYMENT INITIATED";
                color = "#ffc107";
                currentStatusClass = "border-warning";
                icon = "bx-time";
            }
        }
    }

    return { color, currentStatusClass, icon, statusDisplay };
};
const getTextAmountColor = (s) => {
    if (s.paymentStatus === "FAILED" || s.paymentStatus === "REJECTED" ||s.bookingTracking==="CANCELLED") {
        return "#dc3545"; 
    }
    if (s.paymentCompleted === false) {
        return "#ffc107";
    }
    return "#28a745"; 
};


const handleRescheduleDate = async (date) => {    
        const newDateValue = date;        
        setIsEditingWorkDate(false);       
       
        if (!newDateValue) {
            setErrors({ workStartDate: "Date cannot be empty." });
            return;
        }
        const id = isSelectedData._id;
        const dateObj = new Date(newDateValue);

        if (isNaN(dateObj.getTime())) {           
            setErrors({ workStartDate: "Invalid date format selected." });
            return;
        }
        const now = new Date();
        dateObj.setHours(now.getHours());
        dateObj.setMinutes(now.getMinutes());
        dateObj.setSeconds(now.getSeconds());
        const isoString = dateObj.toISOString();    
        const workStartDateISO = DateConverter.convertToTimeZone(isoString, uRLs.TIMEZONE);


        setLoading((prev) => ({ ...prev, updateStartDate: true }));       

        const data = {   
            workStartDate: workStartDateISO,
        };

        try {
            const response = await axiosInstance.patch(
                `farmerbooking/admin/reschedule-date/${id}`,
                data
            );

            if (response && response?.data?.status) {
                showAlert("success", response?.data?.message);
                const updatedBooking = response.data.results;                
            
                setBooking((prevBookings) => { 
                    return prevBookings.map((booking) => { 
                        if (booking._id === id) { 
                            return { ...booking, workStartDate: updatedBooking.workStartDate };
                        }
                        return booking; 
                    });
                });
                
                
                setSelectedData((prevSelected) => ({
                    ...prevSelected,
                    workStartDate: updatedBooking.workStartDate,
                }));
                setEditableWorkDate(response.data.results.workStartDate)
                setErrors({}); 

            } 
        } catch (error) {
         const originalWorkDate = isSelectedData?.workStartDate
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.convertToTimeZone(
                isSelectedData.workStartDate,
                uRLs.TIMEZONE
              )
            ).date
          : "";
         setEditableWorkDate(originalWorkDate)         
            handleError(error, showAlert);         
            setIsEditingWorkDate(true); 
        } finally {
            setLoading((prev) => ({ ...prev, updateStartDate: false }));
        }
      };
      const disabledFutureDates = (current) => {  
        return current && current.isBefore(dayjs().startOf('day'), 'day');
      };
      const coordinates = `${position.lat},${position.lng}`;
      const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(coordinates)}`;

      const confirmCancelBooking = async () => {
        setLoading((prev) => ({ ...prev, cancelBooking: true }));
        checkNetworkStatus();
        try {
          const response = await axiosInstance.patch(
              `farmerbooking/admin/terminate/${isSelectedData._id}`,        
            );   
        if (
              response &&
              response?.data?.status &&
              response?.data?.results
            ) {  
              showAlert("success", response?.data?.message);
             const bookingData = response?.data?.results?.existingBookingData;

                setSelectedData((prev) => ({
                  ...prev,
                  lastStatus: bookingData?.lastStatus,
                  bookingStatus: bookingData?.bookingStatus,
                }));

                setBooking((prev) => ({
                  ...prev,
                  lastStatus: bookingData?.lastStatus,
                  bookingStatus: bookingData?.bookingStatus,
                }));
              handleCloseCancelBooking();
            }

        }  catch (error) {
            handleError(error, showAlert);
            return false;
          } 
          finally {
            setLoading((prev) => ({ ...prev, cancelBooking: false }));
          }
      };

        const handleListDimension = async () => {
          setLoading((prev) => ({ ...prev, dimension: true }));
          checkNetworkStatus();

          try {
        
            const response = await axiosInstance.get("farmerbooking/admin/list-dimension");
            if (
              response &&
              response?.data?.status &&
              response?.data?.results?.length > 0
            ) {
              setDimensionList(response?.data?.results);
            } else {
              setDimensionList([]);
            }     
          } catch (error) {
            setBooking([]);
            handleError(error, showAlert);
            return false;
          } finally {
            setLoading((prev) => ({ ...prev, dimension: false }));
          }
        };
      const handleOpenFOAssessment = () => {
        setOpenFOAssessment(true);
        handleListDimension();
      };
      


  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobileNumber") {
      const onlyNumbers = value.replace(/\D/g, "").slice(0, 10);

      setFormData((prev) => ({
        ...prev,
        [name]: onlyNumbers,
      }));

      setErrors((prev) => ({
        ...prev,
        phone: "",
      }));

      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
const isDimensionChanged =
  selectedDimension &&
  selectedDimension !== String(isSelectedData?.perAcreCost);
const hasNewAssessmentData =
  !!formData.stones ||
  !!formData.nurseryDate ||
  !!formData.nurseryField ||
  !!formData.nurseryDistance ||
  !!formData.waterAvailable ||
  !!formData.fanAvailable ||
  (formData.stayToFieldDistanceInKm !== "" && formData.stayToFieldDistanceInKm !== undefined) ||
  !!formData.farmerProvidesVehicle ||
  !!formData.accommodationFrontPhoto ||
  !!formData.accommodationInsidePhoto;
  const handleEnterKey = (e, nextRef = null, isLast = false) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    const newErrors = {};
    if (
      e.target.name === "name" &&
      !formData.name.trim()
    ) {
      newErrors.name = "Farmer name is required";
      setErrors(newErrors);
      nameRef?.current?.focus();
      return;
    }
if (
  e.target.name === "name" &&
  !/^[A-Za-z\s]+$/.test(formData.name.trim())
) {
  newErrors.name = "Only letters and spaces are allowed";

  setErrors(newErrors);

  nameRef?.current?.focus();

  return;
}
    if (
      e.target.name === "mobileNumber" &&
      !formData.mobileNumber.trim()
    ) {
      newErrors.phone = "Mobile number is required";
      setErrors(newErrors);
      phoneRef?.current?.focus();
      return;
    }

    // MOBILE LENGTH
    if (
      e.target.name === "mobileNumber" && formData.mobileNumber &&
      formData.mobileNumber.trim().length !== 10
    ) {
      newErrors.phone = "Mobile number must be 10 digits";
      setErrors(newErrors);
      phoneRef?.current?.focus();
      return;
    }

    setErrors({});

    // FINAL SUBMIT
      if (isLast) {
       if (
    !formData.name &&
      !formData.mobileNumber &&
      formData.credibility === "" &&
      !isDimensionChanged &&
      !hasNewAssessmentData
      ) {
        return;
      }
      handleAdd(e);
    } else if (nextRef?.current) {
      nextRef.current.focus();
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (clickLockRef.current) return;
    clickLockRef.current = true;
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = "Farmer name is required";
      nameRef?.current?.focus();
    }
    else if (!/^[A-Za-z\s]+$/.test(formData.name.trim())) {
      newErrors.name = "Only letters and spaces are allowed";
      nameRef?.current?.focus();
    }

    else if (!formData.mobileNumber.trim()) {
      newErrors.phone = "Mobile number is required";
      phoneRef?.current?.focus();
    }  
     if (formData.mobileNumber && formData.mobileNumber.trim().length !== 10) {
      newErrors.phone = "Mobile number must be 10 digits";
      phoneRef?.current?.focus();
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      clickLockRef.current = false;
      return;
    }
const payload = new FormData();

if (formData.mobileNumber?.trim()) {
  payload.append("contactNumber", String(formData.mobileNumber).trim());
}

if (formData.name?.trim()) {
  payload.append("contactName", String(formData.name).trim());
}

if (selectedDimension) {
  payload.append("dimension", selectedDimension);
}

if (
  formData.credibility !== "" &&
  formData.credibility !== null &&
  formData.credibility !== undefined
) {
  payload.append(
    "isCredibility",
    formData.credibility === true || formData.credibility === "true"
  );
}

if (formData.stones) {
  payload.append("stones", formData.stones);
}
if (formData.nurseryDate) {
  payload.append("nurseryDate", formData.nurseryDate);
}
if (formData.nurseryField) {
  payload.append("nurseryField", formData.nurseryField);
}
if (formData.nurseryDistance) {
  payload.append("nurseryDistance", formData.nurseryDistance);
}
if (formData.waterAvailable) {
  payload.append("waterAvailable", formData.waterAvailable);
}
if (formData.fanAvailable) {
  payload.append("fanAvailable", formData.fanAvailable);
}
if (formData.stayToFieldDistanceInKm !== "" && formData.stayToFieldDistanceInKm !== undefined) {
  payload.append("stayToFieldDistanceInKm", formData.stayToFieldDistanceInKm);
}
if (formData.farmerProvidesVehicle) {
  payload.append("farmerProvidesVehicle", formData.farmerProvidesVehicle);
}
if (formData.accommodationFrontPhoto) {
  payload.append("accommodationFrontPhoto", formData.accommodationFrontPhoto);
}
if (formData.accommodationInsidePhoto) {
  payload.append("accommodationInsidePhoto", formData.accommodationInsidePhoto);
}

    try {
      setLoading((prev) => ({ ...prev, foAssessment: true }));
      const response = await axiosInstance2.patch(
        `farmerbooking/admin/fo-assessment/${isSelectedData._id}`,
       payload
      );

      if (response?.data?.status) {
        showAlert("success", response?.data?.message);
         const updatedBooking = response.data.results;
         const newHistoryEntry = {
  bookingTracking:updatedBooking.lastStatus,
  time: updatedBooking.updatedAt,
  entryBy: "ADMIN"
};

         setSelectedData((prevSelected) => ({
          ...prevSelected,
                  bookingStatusHistory: [
    ...(prevSelected?.bookingStatusHistory || []),

    newHistoryEntry
  ],
          contactName: updatedBooking.contactName,
          contactNumber: updatedBooking.contactNumber,
          dimension:updatedBooking.dimension,
          lastStatus:updatedBooking.lastStatus,
          isAssessment:updatedBooking.isAssessment,
          perAcreCost:updatedBooking.perAcreCost,
          totalAmount:updatedBooking.totalAmount,
          fieldOfficerAssessment: updatedBooking.fieldOfficerAssessment,
          currentDimensionChangeStatus: updatedBooking.currentDimensionChangeStatus,
          dimensionChangeHistory: updatedBooking.dimensionChangeHistory,
        }));

        setFormData((prev) => ({
          ...prev,
          name: "",
          mobileNumber: "",
          credibility: "",
          stones: "",
          nurseryDate: "",
          nurseryField: "",
          nurseryDistance: "",
          waterAvailable: "",
          fanAvailable: "",
          stayToFieldDistanceInKm: "",
          farmerProvidesVehicle: "",
          accommodationFrontPhoto: null,
          accommodationInsidePhoto: null,
        }));

        setSelectedDimension("");

        setErrors({});

        setOpenFOAssessment(false);
      }
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({ ...prev, foAssessment: false }));
      clickLockRef.current = false;
    }
  };
const handleDimensionDecision = async (decision) => {
  if (decision === "REJECT" && !dimensionRejectReason.trim()) {
    return;
  }
  setDimensionDecisionLoading(true);
  try {
    const data = { decision };
    if (decision === "REJECT") {
      data.rejectionReason = dimensionRejectReason.trim();
    }
    const response = await axiosInstance.patch(
      `farmerbooking/admin/dimension-decision/${isSelectedData._id}`,
      data
    );
    if (response?.data?.status) {
      showAlert("success", response?.data?.message);
      const updatedBooking = response.data.results;
      setSelectedData((prevSelected) => ({
        ...prevSelected,
        dimension: updatedBooking.dimension,
        totalAmount: updatedBooking.totalAmount,
        currentDimensionChangeStatus: updatedBooking.currentDimensionChangeStatus,
        dimensionChangeHistory: updatedBooking.dimensionChangeHistory,
      }));
      setShowDimensionRejectInput(false);
      setDimensionRejectReason("");
    }
  } catch (error) {
    handleError(error, showAlert);
  } finally {
    setDimensionDecisionLoading(false);
  }
};
const humanizeAssessmentValue = (val) => {
  if (val === undefined || val === null || val === "") return "-";
  if (typeof val === "boolean") return val ? "Yes" : "No";
  const str = String(val);
  if (str === "true") return "Yes";
  if (str === "false") return "No";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const getSubmittedByLabel = (submittedBy) => {
  if (!submittedBy) return "Field Officer";
  if (typeof submittedBy === "string") return submittedBy;
  return submittedBy?.fullName || "Field Officer";
};
  
const handleCloseAssign = () => {
  setAssignModal({
    gangLeader: false,
    fieldOfficer: false,
    gangLeaderBatch: false,
  });
};

const handleCloseAssignBatch = () => {
  setAssignModal((prev) => ({ ...prev, gangLeaderBatch: false }));
  handleViewBooking(isSelectedData);
};
const handleImageChange = async (e) => {
  const newFiles = Array.from(e.target.files);

  // 1. ALWAYS clear the previous errors at the start of a new selection
  setErrors({});

  if (newFiles.length === 0) return;

  const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
  const existingFiles = formData.workImages || [];
  const remainingSlots = 3 - existingFiles.length;

  // No slots available at all
  if (remainingSlots <= 0) {
    setErrors({
      workImages: "Maximum 3 images allowed.",
    });
    e.target.value = ""; // Reset the input field text
    return;
  }

  // If user selected more images than allowed remaining slots
  if (newFiles.length > remainingSlots) {
    setErrors({
      workImages: `Only ${remainingSlots} more image(s) allowed. Extra images skipped.`,
    });
    e.target.value = ""; // Reset the input field text so it doesn't display "4 files"
  }

  // Take only the allowed count to process
  const filesToProcess = newFiles.slice(0, remainingSlots);

  try {
    const resizedFiles = [];
    const previewUrls = [];

    for (const file of filesToProcess) {
      // validate type
      if (!allowedTypes.includes(file.type)) {
        setErrors({
          workImages: "Only JPG, JPEG, PNG files allowed.",
        });
        e.target.value = "";
        continue;
      }

      // validate size (Adjusted to 10MB sanity limit, 1GB was a bit high!)
      if (file.size > 10 * 1024 * 1024) { 
        setErrors({
          workImages: "Image size must be below 10MB.",
        });
        e.target.value = "";
        continue;
      }

      const resizedBlob = await resizeImage(file, 1400);

      const resizedFile = new File(
        [resizedBlob],
        file.name,
        { type: "image/jpeg" }
      );

      resizedFiles.push(resizedFile);
      previewUrls.push(URL.createObjectURL(resizedFile));
    }

    setFormData((prev) => ({
      ...prev,
      workImages: [
        ...(prev.workImages || []),
        ...resizedFiles,
      ],
      workImagePreviews: [
        ...(prev.workImagePreviews || []),
        ...previewUrls,
      ],
    }));

    // Clear the input value after successful injection so it resets gracefully
    if (newFiles.length <= remainingSlots) {
      e.target.value = ""; 
    }

  } catch (error) {
    setErrors({
      workImages: "Error processing image.",
    });
    e.target.value = "";
  }
};
const handleFinalImageChange = (e) => {
  const file = e.target.files[0];

  if (!file) return;

  const validTypes = ["image/jpeg", "image/jpg", "image/png"];

  if (!validTypes.includes(file.type)) {
    setErrors((prev) => ({
      ...prev,
      finalImage: "Only JPG, JPEG, PNG allowed"
    }));
    return;
  }

  if (file.size > 1024 * 1024 * 1024) {
    setErrors((prev) => ({
      ...prev,
      finalImage: "Image size should be below 1GB"
    }));
    return;
  }

  setErrors((prev) => ({
    ...prev,
    finalImage: ""
  }));

  setFormData((prev) => ({
    ...prev,
    finalImage: file,
    finalImagePreview: URL.createObjectURL(file)
  }));
};
const handleRemoveImage = (index) => {
  const updatedFiles = [...formData.workImages];
  const updatedPreviews = [...formData.workImagePreviews];

  updatedFiles.splice(index, 1);
  updatedPreviews.splice(index, 1);

  setFormData((prev) => ({
    ...prev,
    workImages: updatedFiles,
    workImagePreviews: updatedPreviews,
  }));
};

const handleSaveUploadImages = async () => {
  if (formData.workImages.length === 0) {
    setErrors({
      workImages: "Please upload at least one image.",
    });
    return;
  }
   setLoading((prev) => ({ ...prev, workImage: true }));
 try {

    const payload = new FormData();

    formData.workImages.forEach((img) => {
      payload.append("workImages", img);
    });

    const response = await axiosInstance2.patch(
      `farmerbooking/admin/upload-work-images/${isSelectedData?._id}`,
      payload
          );
             const updatedBooking = response.data.results;
             
//  setSelectedData((prevSelected) => ({
//           ...prevSelected,          
//           workStatus:updatedBooking.workStatus,
//           workImages: updatedBooking.workImages, 
//         }));

        setSelectedData((prevSelected) => {     
      let updatedHistory = [...(prevSelected.bookingStatusHistory || [])];
           const hasWorkStarted = updatedHistory.some(
        (s) => s.bookingTracking === "WORKINPROGRESS"
      );
      const hasImages = updatedBooking.workImages && updatedBooking.workImages.length > 0;

       if (!hasWorkStarted && hasImages) {
        updatedHistory.push({
          _id: updatedBooking._id,
          bookingTracking: "WORKINPROGRESS",
          entryBy: updatedBooking.lastUpdatedBy || "OWNER",
          time: updatedBooking.updatedAt,
        });
      }

      return {
        ...prevSelected,
        workStatus: updatedBooking.workStatus,
        workImages: updatedBooking.workImages,
        bookingStatusHistory: updatedHistory, // Saves the modified array here
      };
    });
    showAlert(
      "success",
      "Images uploaded successfully."
    );

    handleCloseUploadWorkImages();

  } catch (error) {

    showAlert(
      "error",
      error?.response?.data?.message ||
        "Failed to upload images."
    );
  }finally{
     setLoading((prev) => ({ ...prev, workImage: false }));
  }
};

const handleUploadFinalImages = async () => {

  try {

    let newErrors = {};

    if (!formData.finalImage) {
      newErrors.finalImage = "Image is required";
    }

    if (
      formData.latitude === "" ||
      formData.latitude < -90 ||
      formData.latitude > 90
    ) {
      newErrors.latitude =
        "Latitude should be between -90 and 90";
    }

    if (
      formData.longitude === "" ||
      formData.longitude < -180 ||
      formData.longitude > 180
    ) {
      newErrors.longitude =
        "Longitude should be between -180 and 180";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    const data = new FormData();

    data.append("image", formData.finalImage);

    data.append(
      "location",
      JSON.stringify({
        longitude: Number(formData.longitude),
        latitude: Number(formData.latitude)
      })
    );

    const response = await axiosInstance2.patch(
      `farmerbooking/admin/upload-final-work/${isSelectedData?._id}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    const updatedBooking = response.data.results;

    setSelectedData((prevSelected) => ({
      ...prevSelected,
      workStatus: updatedBooking.workStatus,
      geoImage: updatedBooking.geoImage?.image
    }));

    showAlert(
      "success",
      "Image uploaded successfully."
    );

    handleCloseUploadImages();

  } catch (error) {

    showAlert(
      "error",
      error?.response?.data?.message || "Upload failed"
    );
  }
};
const handleOpenMeasurementModal = () => {
  setOpenMeasurementModal(true);
};
const handleCloseMeasurementModal = () => {
  setOpenMeasurementModal(false);
};

const handleSaveMeasurement = async () => { 
  setLoading((prev) => ({ ...prev, measureLoad: true }));
  try {
    const data = {
      measurementInAcres: Number(measurement),
    };
    const response = await axiosInstance.patch(
      `farmerbooking/admin/measurement/${isSelectedData._id}`,
      data
    );
    if (response && response?.data?.status && response?.data?.results) {
      showAlert("success", response?.data?.message);
      const updatedBooking = response.data.results;
      
      setSelectedData((prevSelected) => {      
        const updatedHistory = [...(prevSelected?.bookingStatusHistory || [])];
                const currentMeasureStatus = updatedBooking?.measurementStatus?.[0]?.status; // "PENDING" or "ACCEPTED"
           const hasMeasurementRecorded = updatedHistory.some(
          (s) => s.bookingTracking === "GLMEASUREMENTDONE"
        );
     
        if (!hasMeasurementRecorded && currentMeasureStatus === "ACCEPTED") {
          updatedHistory.push({
            _id: updatedBooking._id,
            bookingTracking: "GLMEASUREMENTDONE",
            entryBy: updatedBooking.lastUpdatedBy || "OWNER",
            time: updatedBooking.updatedAt || new Date().toISOString(), // This provides the time your UI is looking for!
          });
        }

        return {
          ...prevSelected,
          perAcreCost: updatedBooking.perAcreCost,
          totalAmount: updatedBooking.totalAmount, 
          balanceAmount: updatedBooking.balanceAmount,      
          isMeasurement: updatedBooking.isMeasurement,
          time: updatedBooking.updatedAt,
          measurementStatus: updatedBooking.measurementStatus, 
          bookingStatusHistory: updatedHistory, // CRUCIAL: Uncommented and updated so UI can find matchedHistoryItem.time
        };
      });
    }
    // if (response && response?.data?.status && response?.data?.results) {
    //   showAlert("success", response?.data?.message);
    //   const updatedBooking = response.data.results;
      
    //   setSelectedData((prevSelected) => {
    //     const updatedHistory = [...(prevSelected?.bookingStatusHistory || [])];
        
    //     // Check current status from the array response
    //     const currentMeasureStatus = updatedBooking?.measurementStatus?.[0]?.status; // "PENDING" or "ACCEPTED"

     
    //     return {
    //       ...prevSelected,
    //       perAcreCost: updatedBooking.perAcreCost,
    //       totalAmount: updatedBooking.totalAmount, 
    //       balanceAmount: updatedBooking.balanceAmount,      
    //       isMeasurement: updatedBooking.isMeasurement,
    //       time:updatedBooking.updatedAt,
    //       measurementStatus: updatedBooking.measurementStatus, // CRUCIAL: Saves the array for conditional checks
    //       // bookingStatusHistory: updatedHistory,
        
    //     };
    //   });
    // }
    handleCloseMeasurementModal();
  } catch (error) {
    handleError(error, showAlert);
    return false;
  } finally {
    setLoading((prev) => ({ ...prev, measureLoad: false }));
  }
};
const handleUploadWorkImages = () => {
  setOpenWorkImageModal(true);
};
const handleUploadImages = () => {
  setOpenImageModal(true);
};
const handleCloseUploadImages = () => {
  setOpenImageModal(false);
  console.log("false")
};


const handleCloseUploadWorkImages = () => {
  setOpenWorkImageModal(false);
  setErrors("")
   setFormData({
          workImages: [],
          workImagePreviews: [],       
        });
};
const showManualPaymentCompleted =
  Number(isSelectedData?.balanceAmount || 0) <= 0 &&
  Number(isSelectedData?.totalPaid || 0) > 0;
// Same rule the API applies on completion: every non-cancelled Gang Leader
// sub-booking has its measurement accepted and its work completed.
// (parentBookingId check: ignore a previous booking's list while this one loads)
const activeSubBookings = completeModalSubBookings.filter(
  (sb) => sb.parentBookingId === isSelectedData?._id && sb.bookingStatus !== "CANCELLED"
);
const isSplitWorkCompleted =
  activeSubBookings.length > 0 &&
  activeSubBookings.every(
    (sb) => sb.isGlMeasurementAccepted === true && sb.isGlWorkCompleted === true
  );
const canCompleteBooking = isSelectedData?.supportsSplit
  ? isSplitWorkCompleted && showManualPaymentCompleted
  : isSelectedData?.isMeasurement === true &&
    isSelectedData?.geoImage?.image &&
    isSelectedData?.workStatus === "COMPLETED" &&
    showManualPaymentCompleted;

// "Next Step" banner — a single plain-language sentence telling the admin
// what to do next, computed from fields already on isSelectedData. Only
// shown for primary bookings (sub-bookings already get their own dedicated
// status banner above).
const getNextStepBanner = () => {
  if (isSelectedData?.isPrimaryBooking === false) return null;
  if (["CANCELLED", "REFUND", "BOOKINGCOMPLETED"].includes(isSelectedData?.lastStatus)) return null;

  if (isSelectedData?.currentDimensionChangeStatus === "PENDING_FARMER") {
    return { variant: "alert-info", text: "Dimension change is pending the farmer's approval." };
  }
  if (isSelectedData?.currentDimensionChangeStatus === "PENDING_ADMIN") {
    return { variant: "alert-warning", text: "A dimension change request needs your approval." };
  }

  const history = Array.isArray(isSelectedData?.bookingStatusHistory) ? isSelectedData.bookingStatusHistory : [];
  const completedKeys = history.map((s) => s.bookingTracking);
  const hasAssessmentDone = completedKeys.includes("FOASSESSMENTDONE");
  const hasAdvancePaid = completedKeys.includes("ADVANCEPAID");
  const hasBookingConfirmed = completedKeys.includes("BOOKINGCONFIRMED") || isSelectedData?.lastStatus === "BOOKINGCONFIRMED";
  const glAllocations = isSelectedData?.glAllocations || [];

  if (!hasAssessmentDone) {
    // Early-stage gap isn't the focus of this banner — skip it here.
    return null;
  }

  if (!hasAdvancePaid) {
    return { variant: "alert-warning", text: "Record an advance payment to proceed." };
  }

  if (!hasBookingConfirmed && glAllocations.length === 0) {
    return { variant: "alert-info", text: "Confirm this booking to allocate Captains." };
  }

  if (isSelectedData?.supportsSplit && glAllocations.length === 0) {
    return { variant: "alert-info", text: "Assign Captains to this booking." };
  }

  if (isSelectedData?.supportsSplit && isSplitWorkCompleted) {
    return Number(isSelectedData?.balanceAmount || 0) <= 0
      ? { variant: "alert-info", text: "All Captains have finished. This booking is ready to be marked completed." }
      : { variant: "alert-warning", text: "All Captains have finished. Record the balance payment to complete this booking." };
  }

  if (isSelectedData?.supportsSplit && glAllocations.length > 0) {
    const acceptedCount = glAllocations.filter((a) => a.status === "ACCEPTED").length;
    const total = glAllocations.length;
    return acceptedCount < total
      ? { variant: "alert-warning", text: `${acceptedCount} of ${total} Captains assigned have accepted so far.` }
      : { variant: "alert-info", text: `All ${total} Captains assigned have accepted.` };
  }

  return { variant: "alert-info", text: "This booking looks ready to be marked completed." };
};
const nextStepBanner = getNextStepBanner();


return (
    <div>


      
        <div className={isOpen || assignModal.gangLeader || assignModal.fieldOfficer || assignModal.gangLeaderBatch ?"":"modal-backdrop show"}></div>
      <div
        className="modal show d-block"
        id="BookingModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-scrollable modal-xl orderModel">
          <div className="modal-content">
            <div className="modal-header border-bottom-0 py-3">
              <h6 className="modal-title">
                Booking Details - <b>{isSelectedData?.bookingNumber}</b> - 
                   {isSelectedData?.bookingTime
                                ? DateConverter.ISOToDisplayFormat(
                                    DateConverter.convertToTimeZone(
                                      isSelectedData?.bookingTime,
                                      uRLs.TIMEZONE
                                    )
                                  ).date || ""
                                : ""}
              </h6>

              <button
                type="button"
                className="btn-close border"
                onClick={onClose}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div
              className="modal-body bg-light-background "
              style={{
                overflow: "hidden",
              }}
            >
              <style>
                {`
      @media (max-width: 768px) {
        .modal-body.bg-light-background {
          overflow: auto !important; 
        }
      }
    `}
              </style>
              {nextStepBanner && (
                <div className={`alert ${nextStepBanner.variant} d-flex align-items-start gap-2 mb-2 py-2 px-3 font-13`} role="alert">
                  <i className="bx bx-info-circle fs-5"></i>
                  <div><strong>Next step:</strong> {nextStepBanner.text}</div>
                </div>
              )}
              <div className="">
                <div className="row">
                  <div className="col-md-8 col-sm-12 mb-3">
                    <div className="card mb-0 mt-0 scroll-container rounded-0">
                      <div
                        style={{
                          position: "sticky",
                          top: "0",
                          zIndex: "10",
                          background: "#fff",
                        }}
                      >
                        {activeView !== "status" ? (
                          <div className="d-flex justify-content-between align-items-center box-header bg-light-theme p-2 rounded-start-0  rounded-end-0">
                            <h6 className="modal-title bg-light-theme-text  ">
                              Booking Info
                            </h6>
                            <div className="view-actions">
                              <Tooltip
                                title="View Status"
                                arrow
                                PopperProps={{
                                  modifiers: [
                                    {
                                      name: "preventOverflow",
                                      options: {
                                        boundary: "window",
                                      },
                                    },
                                  ],
                                }}
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "white",
                                      color: "black",
                                      border: "1px solid black",
                                      fontSize: "12px",
                                      boxShadow:
                                        "0px 0px 5px rgba(0, 0, 0, 0.2)",
                                    },
                                  },
                                  arrow: {
                                    sx: {
                                      color: "white",
                                      borderBottom: "1px solid black",
                                    },
                                  },
                                }}
                              >
                                {" "}
                                <button type="button" onClick={handleClose}>
                                  <i className="lni lni-eye me-2"></i>{" "}
                                  <span className="font-14">Status</span>
                                </button>
                              </Tooltip>
                            </div>
                          </div>
                        ) : (
                          <button
                            className="accordion-button rounded-start-0  rounded-end-0"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="true"
                            aria-controls="flush-collapseOne"
                          >
                            Booking Info
                          </button>
                        )}
                      </div>
                      <div className="card-body ">
                        <div className="d-flex justify-content-between">
                            <p className="mb-0 text-left">Booking No: <b>{isSelectedData?.bookingNumber}</b></p>
                           
                          <p className="mb-0 text-right mb-1">
                            
                             <span
  className={`badge ${ 
    isSelectedData?.lastStatus === "CANCELLED"
      ? "app-badge bg-label-danger"
      : isSelectedData?.lastStatus === "PLACED"
      ? "app-badge bg-label-warning"
      : isSelectedData?.lastStatus === "GLMEASUREMENTDONE"
        ? "bg-label-spring"
         : isSelectedData?.lastStatus === "BOOKINGCOMPLETED"
        ? "bg-label-spring"
            : isSelectedData?.lastStatus === "WORKCOMPLETED"
        ? "bg-label-moon"
           : isSelectedData?.lastStatus === "WORKINPROGRESS"
        ? "bg-label-infoss"
      : isSelectedData?.lastStatus === "ACCEPTED"
      ? "app-badge bg-label-spring"
      : isSelectedData?.lastStatus === "PAYMENT"
      ? "app-badge bg-label-moon"
       : isSelectedData?.lastStatus === "BOOKINGCONFIRMED"
      ? "app-badge bg-label-moon"
      : isSelectedData?.lastStatus === "FOALLOCATED"
      ? "app-badge bg-label-fall"
      : isSelectedData?.lastStatus === "ADVANCEPENDING"
      ? "app-badge bg-label-infoss"
      : isSelectedData?.lastStatus === "ADVANCEPAID"
      ? "app-badge bg-label-moon"
       : isSelectedData?.lastStatus === "REFUND"
      ? "bg-label-danger"
      : isSelectedData?.lastStatus === "FOASSESSMENTDONE"
      ? "app-badge bg-label-deep-purple"
      : "bg-secondary"
  }`}
>
  {isSelectedData?.lastStatus === "CREATED"
    ? "UnPlaced"
    : isSelectedData?.lastStatus === "ACCEPTED"
    ? "Order processing"
    : isSelectedData?.lastStatus === "FOASSESSMENTDONE"
    ? "FO Assessment Done"
    : isSelectedData?.lastStatus === "FOALLOCATED"
    ? "FO Allocated"
    : isSelectedData?.lastStatus === "ADVANCEPENDING"
    ? "Advance Pending"
    : isSelectedData?.lastStatus === "ADVANCEPAID"
    ? "Advance Paid"
    : isSelectedData?.lastStatus === "BOOKINGCONFIRMED"
      ? "Booking Confirmed"
      : isSelectedData?.lastStatus ==="GLMEASUREMENTDONE"
       ?"  Measurement Done"
          : isSelectedData?.lastStatus ==="BOOKINGCOMPLETED"
       ?"  Booking Completed"
          : isSelectedData?.lastStatus ==="GLMEASUREMENTPENDING"
       ?"  Measurement Pending"
          : isSelectedData?.lastStatus === "WORKINPROGRESS"
      ? "Work In Progres"
        : isSelectedData?.lastStatus === "WORKCOMPLETED"
      ? "Work Completed"
    : isSelectedData?.lastStatus}
</span>
                         
                          </p>
                        </div>
                         <div className="d-flex justify-content-between">                       
                        <p className="mb-2 text-left">Name: <b>{capitalizeFirstLetter(isSelectedData?.name)||"-" }</b></p>                          
                           {isSelectedData?.bookingStatus === "ACCEPTED" && !isSelectedData?.supportsSplit && !(
                        isSelectedData?.bookingStatusHistory?.some(history =>
                          history.bookingTracking === 'PAYMENT'
                        ))&& (
                                <div className="ms-auto mb-2">
                                  {!isSelectedData?.assignedTo &&(
                                  <button
                                type="button"
                                className="btn btn-sm btn-label-navy"   
                                 onClick={() => {
                                                  setShowAssignOptions(false);
                                                  setAssignModal({ gangLeader: true, fieldOfficer: false });
                                                }}  
                              >
                                <i className="bx bx-user-plus"></i> Assign Captain
                              </button>
                           
                              )}
                                </div>)}
                                {isSelectedData?.supportsSplit && (canAllocateGangLeaders(isSelectedData) || isSelectedData?.glAllocations?.length > 0) && (
                                <div className="ms-auto mb-2">
                                  <button
                                type="button"
                                className="btn btn-sm btn-label-navy"
                                 onClick={() => setAssignModal((prev) => ({ ...prev, gangLeaderBatch: true }))}
                              >
                                <i className="bx bx-group"></i> Captain Allocations
                                {isSelectedData?.glAllocations?.length > 0 && ` (${isSelectedData.glAllocations.length})`}
                              </button>
                                </div>)}
                                </div>


                               <div className="row">
                                 {isSelectedData?.assignedTo && (                       
                                   <div className="col-md-4 col-sm-12">
                                 
                                   
                                  <div className="border radius-10 p-2 mb-2  bg-label-navy">
                                    <h6 className="fw-bold me-2 mb-1 font-13" style={{color:"#5f82c5"}}> 
                                  Captain Info:                                 
                                </h6>
                                  <div className="d-flex">
                                    <p className="mb-1 me-2 fw-bold text-black"> {isSelectedData?.assignedTo?.mobileNumber || "-"},</p>
                                    <p className="mb-0 fw-bold text-black"> {capitalizeFirstLetter(isSelectedData?.assignedTo?.fullName) || "-"}</p>
                                    </div>
                              </div>
                                                             

                              </div>
                                )}    {isSelectedData?.assignedToFieldOfficer && (
                                 <div className="col-md-4 col-sm-12">                               
                                   
                                  <div className="border radius-10 p-2 mb-2 bg-label-wave ">
                                    <h6 className="fw-bold me-2 mb-1 font-13" style={{color:"#5f82c5"}}> 
                                   Field Officer Info:                                  
                                </h6>
                                  <div className="d-flex">
                                    <p className="mb-1 me-2 fw-bold text-black"> {isSelectedData?.assignedToFieldOfficer?.mobileNumber || "-"},</p>
                                    <p className="mb-0 fw-bold text-black"> {capitalizeFirstLetter(isSelectedData?.assignedToFieldOfficer?.fullName) || "-"}</p>
                                    </div>
                              </div>                                                           

                              </div>
                               )}
                                  {isSelectedData?.contactName &&(
                                  <div className="col-md-4 col-sm-12">
                                 
                                   
                                  <div className="border radius-10 p-2 mb-2 ">
                                    <h6 className="fw-bold me-2 mb-1 font-13" style={{color:"#5f82c5"}}> 
                                  Contact Info:                                 
                                </h6>
                                   <div className="d-flex">
                                    <p className="mb-1 me-2 fw-bold text-black"> {isSelectedData?.contactName||"-"},</p>
                                    <p className="mb-0 fw-bold text-black"> {capitalizeFirstLetter(isSelectedData?.contactNumber) || "-"}</p>
                                    </div>
                                </div>

                                  </div>
                                  )}
                                  {isSelectedData?.fieldOfficerAssessment && (
                                  <div className="col-12">
                                  <div className="border radius-10 p-2 mb-2">
                                    <h6 className="fw-bold me-2 mb-2 font-13" style={{color:"#5f82c5"}}>
                                  Field Officer Assessment:
                                </h6>
                                <div className="row g-2">
                                  <div className="col-md-3 col-sm-6"><p className="mb-0 font-12"><span className="text-muted">Stones:</span> <b className="text-black">{humanizeAssessmentValue(isSelectedData.fieldOfficerAssessment?.stones)}</b></p></div>
                                  <div className="col-md-3 col-sm-6"><p className="mb-0 font-12"><span className="text-muted">Nursery Age:</span> <b className="text-black">{formatNurseryAge(isSelectedData.fieldOfficerAssessment)}</b></p></div>
                                  <div className="col-md-3 col-sm-6"><p className="mb-0 font-12"><span className="text-muted">Nursery Field:</span> <b className="text-black">{humanizeAssessmentValue(isSelectedData.fieldOfficerAssessment?.nurseryField)}</b></p></div>
                                  <div className="col-md-3 col-sm-6"><p className="mb-0 font-12"><span className="text-muted">Nursery Distance:</span> <b className="text-black">{formatNurseryDistance(isSelectedData.fieldOfficerAssessment)}</b></p></div>
                                  <div className="col-md-3 col-sm-6"><p className="mb-0 font-12"><span className="text-muted">Stay Distance:</span> <b className="text-black">{isSelectedData.fieldOfficerAssessment?.stayToFieldDistanceInKm ?? "-"} km</b></p></div>
                                  <div className="col-md-3 col-sm-6"><p className="mb-0 font-12"><span className="text-muted">Vehicle Provided:</span> <b className="text-black">{humanizeAssessmentValue(isSelectedData.fieldOfficerAssessment?.farmerProvidesVehicle)}</b></p></div>
                                  <div className="col-md-3 col-sm-6"><p className="mb-0 font-12"><span className="text-muted">Water Available:</span> <b className="text-black">{humanizeAssessmentValue(isSelectedData.fieldOfficerAssessment?.accommodation?.waterAvailable)}</b></p></div>
                                  <div className="col-md-3 col-sm-6"><p className="mb-0 font-12"><span className="text-muted">Fan Available:</span> <b className="text-black">{humanizeAssessmentValue(isSelectedData.fieldOfficerAssessment?.accommodation?.fanAvailable)}</b></p></div>
                                </div>
                                {(isSelectedData.fieldOfficerAssessment?.accommodation?.frontPhoto || isSelectedData.fieldOfficerAssessment?.accommodation?.insidePhoto) && (
                                <div className="d-flex gap-2 mt-2">
                                  {isSelectedData.fieldOfficerAssessment.accommodation?.frontPhoto && (
                                    <img src={isSelectedData.fieldOfficerAssessment.accommodation.frontPhoto} alt="Accommodation Front" style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "6px", border: "1px solid #ddd" }} />
                                  )}
                                  {isSelectedData.fieldOfficerAssessment.accommodation?.insidePhoto && (
                                    <img src={isSelectedData.fieldOfficerAssessment.accommodation.insidePhoto} alt="Accommodation Inside" style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "6px", border: "1px solid #ddd" }} />
                                  )}
                                </div>
                                )}
                                {(isSelectedData.fieldOfficerAssessment?.submittedBy || isSelectedData.fieldOfficerAssessment?.submittedAt) && (
                                <p className="text-muted font-11 mt-2 mb-0">
                                  Submitted by {getSubmittedByLabel(isSelectedData.fieldOfficerAssessment?.submittedBy)}
                                  {isSelectedData.fieldOfficerAssessment?.submittedAt && (
                                    <> on {DateConverter.ISOToDisplayFormat(DateConverter.convertToTimeZone(isSelectedData.fieldOfficerAssessment.submittedAt, uRLs.TIMEZONE)).date}</>
                                  )}
                                </p>
                                )}
                                  </div>
                                  </div>
                                  )}
                                {/* hide measure */}
                                {/* <div className="col-md-12 col-sm-12">
                              {isSelectedData?.bookingStatus === "ACCEPTED" &&                         
                          !isSelectedData?.isMeasurement && (
                            <div className="border radius-10 p-2 mb-2">
  
                           <h6 className="fw-bold me-2 mb-1 font-13" style={{color:"#5f82c5"}}> 
                            Measurement 
                          </h6>

                          <div className="d-flex align-items-center gap-2">

                            <input
                              type="number"
                              className="form-control"
                              style={{ maxWidth: "200px" }}
                              value={measurement}
                              onChange={(e) => {
                                let val = e.target.value;

                                if (val === "") {
                                  setMeasurement("");
                                  return;
                                }

                                if (/^\d+(\.\d{0,1})?$/.test(val)) {
                                  setMeasurement(val);
                                }
                              }}
                            />
                        {loading.measureLoad ? (
                           <button className="btn btn-primary pb-0 text-right" disabled>
                             <CircularProgress size={22} className="text-white" />
                              </button>
                           ) : (
                            <button
                              className="btn btn-primary "
                              onClick={handleSaveMeasurement}
                            ><i className="bx bx-check"></i>
                              Accept
                            </button>
                                                                )}

                          </div>
                        </div>
                            )}
                             </div> */}
                              {/* hide measure */}
                          {/* <div className="col-4">
                            <div className="card mb-2 border-0 shadow-sm">
                            <div className="card-body py-2 px-3 d-flex justify-content-between align-items-center border rounded-4 cursor-pointer "  onClick={handleOpenMeasurementModal}>

                              <div>
                                <div className=" small text-blue font-13" style={{color:"#5f82c5"}}>Measurement</div>
                                <div className="fw-bold fs-6">
                                  {isSelectedData?.numberOfAcres} Acre
                                </div>
                              </div>
                             
                                 <button class="btn-label-primary shadow-none me-2 edit-date ms-2"> <i 
                                                className="bx bx-pencil  cursor-pointer text-blue" 
                                              //  onClick={handleOpenMeasurementModal}
                                              
                                            ></i></button>
                            
                         

                            </div>
                          </div>
                            </div> */}
                            </div>
                          
                        <div className="card mb-2">
                          <button
                            className="background-none pb-0 accordion-button "
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="true"
                            aria-controls="flush-collapseOne"
                          >
                            Work Details
                          </button>

                          <div className="row g-0 align-items-center pt-0 p-2">
                            <DetailItem
                              iconClass="bx-phone"
                              title="Phone"
                              value={isSelectedData?.mobileNumber || "-"}
                            />
                          

                        <div className="col-lg-4 col-md-6">
                            <div className="p-1">
                                <div className="d-flex align-items-start gap-2 p-2 rounded">
                                    <div className="detail-icon fs-5 text-primary">
                                        <i className={`bx bx-calendar-event font-24`}></i>
                                    </div>
                                    <div className="detail-info flex-grow-1">
                                        <h6 className="fw-bold text-muted mb-1">
                                            Work Start Date 
                                            {isSelectedData?.lastStatus !== "CANCELLED" && 
                                               isSelectedData?.bookingStatus === "ACCEPTED" && (
                                          <button class="btn-label-primary shadow-none me-2 edit-date ms-2"> <i 
                                                className="bx bx-pencil  cursor-pointer text-blue" 
                                              onClick={() =>  setIsEditingWorkDate(true)}
                                              
                                            ></i></button>
                                            )}
                                        </h6>

                                        {isEditingWorkDate ? (                   
                                            <div className="d-flex align-items-center gap-2">                                               
                                                
                                                  <DatePicker
                                                style={{ width: "150px" }}
                                                value={isEditableWorkDate ? dayjs(isEditableWorkDate) : null} 
                                                onChange={(date) => {
                                                  const iso = date ? date.toISOString() : "";
                                                  setEditableWorkDate(iso);
                                                  handleRescheduleDate(iso);
                                                }}
                                                disabledDate={disabledFutureDates}
                                                format="DD MMM YYYY"
                                                allowClear={false}
                                              />
                                                
                                            </div>
                                        ) : (                 
                                            <p className="mb-0 fw-bold text-dark">
                                                {isSelectedData?.workStartDate
                                                    ? DateConverter.ISOToDisplayFormat(
                                                        DateConverter.convertToTimeZone(
                                                            isSelectedData?.workStartDate,
                                                            uRLs.TIMEZONE
                                                        )
                                                    ).date || ""
                                                    : "N/A"}
                                            </p>
                                        )}
                                        
                                        {errors.workStartDate && (
                                            <p className="text-danger mt-1 mb-0 font-12" >
                                                {errors.workStartDate}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                            <DetailItem
                              iconClass="bx bx-rupee"
                              title="Amount Paid"
                              value={`₹${isSelectedData.totalPaid} `}
                            />
                            <DetailItem
                              col="col-lg-4 col-md-6"
                              iconClass="bx-spa"
                              title="No of Acres"
                              value={`${isSelectedData.numberOfAcres} acres`}
                            />

                            <CheckboxDetailItem
                              iconClass="bx-comment-detail"
                              title="Arrangements"
                              
                              isChecked={isSelectedData?.isArrangement}
                            />
                            <DetailItem
                              iconClass="bx bx-category"
                              title="Dimension"
                              col="col-lg-4 col-md-6"
                              value={`${capitalizeFirstLetter(
                                isSelectedData?.dimension?.dimension || "-"
                              )} ${
                                isSelectedData?.dimension?.amount
                                  ? `- ₹${isSelectedData?.dimension?.amount}`
                                  : ""
                              }`}
                          />
                          {isSelectedData?.currentDimensionChangeStatus === "PENDING_FARMER" && (
                            <div className="col-12 mt-1">
                              <div className="alert alert-info mb-2 py-2 px-3 font-13" role="alert">
                                Dimension change to <b>{capitalizeFirstLetter(isSelectedData?.dimensionChangeHistory?.[isSelectedData.dimensionChangeHistory.length - 1]?.dimension)}</b>
                                {" "}(<span>&#8377;</span>{isSelectedData?.dimensionChangeHistory?.[isSelectedData.dimensionChangeHistory.length - 1]?.newTotalAmount}) is pending the farmer's approval.
                              </div>
                            </div>
                          )}
                          {isSelectedData?.currentDimensionChangeStatus === "PENDING_ADMIN" && (
                            <div className="col-12 mt-1">
                              <div className="alert alert-warning mb-2 py-2 px-3 font-13" role="alert">
                                <div className="mb-2">
                                  Dimension change to <b>{capitalizeFirstLetter(isSelectedData?.dimensionChangeHistory?.[isSelectedData.dimensionChangeHistory.length - 1]?.dimension)}</b>
                                  {" "}(<span>&#8377;</span>{isSelectedData?.dimensionChangeHistory?.[isSelectedData.dimensionChangeHistory.length - 1]?.newTotalAmount}) needs your approval.
                                </div>
                                {!showDimensionRejectInput ? (
                                  <div className="d-flex gap-2">
                                    {dimensionDecisionLoading ? (
                                      <button className="btn btn-sm btn-success" disabled>
                                        <CircularProgress size={14} className="text-white" />
                                      </button>
                                    ) : (
                                      <>
                                        <button type="button" className="btn btn-sm btn-success" onClick={() => handleDimensionDecision("ACCEPT")}>
                                          <i className="bx bx-check"></i> Approve
                                        </button>
                                        <button type="button" className="btn btn-sm btn-danger" onClick={() => setShowDimensionRejectInput(true)}>
                                          <i className="bx bx-x"></i> Reject
                                        </button>
                                      </>
                                    )}
                                  </div>
                                ) : (
                                  <div className="d-flex gap-2 align-items-center">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="Reason for rejection"
                                      value={dimensionRejectReason}
                                      onChange={(e) => setDimensionRejectReason(e.target.value)}
                                      style={{ maxWidth: "220px" }}
                                    />
                                    {dimensionDecisionLoading ? (
                                      <button className="btn btn-sm btn-danger" disabled>
                                        <CircularProgress size={14} className="text-white" />
                                      </button>
                                    ) : (
                                      <>
                                        <button type="button" className="btn btn-sm btn-danger" disabled={!dimensionRejectReason.trim()} onClick={() => handleDimensionDecision("REJECT")}>
                                          Confirm Reject
                                        </button>
                                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => { setShowDimensionRejectInput(false); setDimensionRejectReason(""); }}>
                                          Cancel
                                        </button>
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                     <div className="row ps-0">
                    <div className="col-12">
                      {latestMeasurement && (
                        <div className="col-6 mt-2">
                          <div className="border rounded p-2 shadow-sm bg-white">

                            {/* Header */}
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6 className="mb-0 fw-bold text-primary">
                                Measurement
                              </h6>

                              <span
                                className={`badge rounded-pill px-3 py-2 ${
                                  latestMeasurement.status === "ACCEPTED"
                                    ? "bg-success-subtle text-success"
                                    : "bg-warning-subtle text-warning"
                                }`}
                                style={{ fontSize: "12px", fontWeight: 600 }}
                              >
                                <i className="bx bxs-check-circle me-1"></i>
                                {capitalizeFirstLetter(latestMeasurement.status?.toLowerCase())}
                              </span>
                            </div>

                            {/* Content */}
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <small className="text-muted me-1">Measured By:</small>
                                <small className="fw-semibold text-dark">
                                  {latestMeasurement.role === "FIELDOFFICER"
                                    ? "Field Officer"
                                    : latestMeasurement.role === "OWNER"
                                    ? "Owner"
                                    : "-"}
                                </small>
                              </div>

                              <div className="text-end">
                                <small className="text-muted me-1">Area:</small>
                                <small className="fw-bold text-success">
                                  {latestMeasurement.measurementInAcres} Acres
                                </small>
                              </div>
                            </div>

                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                            <LongDetailItem
                              title="Work Instruction"
                              value={isSelectedData?.workInstruction || "-"}
                            />
                          </div>
                        </div>
                        <div className="card mb-3">
                          <button
                            className="background-none pb-0 accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="true"
                            aria-controls="flush-collapseOne"
                            fdprocessedid="5b1j1a"
                          >
                            Location{" "}
                          </button>
                          <div className="card-body p-0">
                            <div className="col-12 col-lg-12 d-block  ">
                              <div className="row">
                                <div className="col">
                                  <div className="">
                               
                                    <div className="row g-0 align-items-center">
                                      <div className="col-lg-7 border-end">
                                       <a 
                                            href={mapUrl} 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            link
                                            style={{ display: 'block', textDecoration: 'none', color: 'inherit' }}
                                        >
                                        <div className="p-3 align-self-center">
                                          {isPreLoading ? (
                                            <Skeleton
                                              variant="rectangular"
                                              width="100%"
                                              height={200}
                                            />
                                          ) : (
                                            <LoadScript googleMapsApiKey={uRLs.mapKey}>
                                              <GoogleMap
                                                mapContainerStyle={
                                                  mapContainerStyle
                                                }
                                                center={position}
                                                zoom={13}
                                              >
                                                <Marker
                                                  position={position}
                                                  onClick={() =>
                                                    setSelectedMarker(position)
                                                  }
                                                />
                                                {selectedMarker && (
                                                  <InfoWindow
                                                    position={selectedMarker}
                                                    onCloseClick={() =>
                                                      setSelectedMarker(null)
                                                    }
                                                  >
                                                    <div>
                                                      <h6>Booking Address</h6>
                                                      <p>
                                                        {
                                                          isSelectedData?.addressLine1
                                                        }
                                                        ,{" "}
                                                        {
                                                          isSelectedData?.addressLine2
                                                        }
                                                        , {isSelectedData.state}
                                                        ,{" "}
                                                        {
                                                          isSelectedData.district
                                                        }
                                                        ,{" "}
                                                        {isSelectedData.country}{" "}
                                                        -{" "}
                                                        {isSelectedData.pincode}
                                                      </p>
                                                    </div>
                                                  </InfoWindow>
                                                )}
                                              </GoogleMap>
                                            </LoadScript>
                                          )}
                                        </div>
                                        </a>
                                      </div>
                                      <div className="col-lg-5">
                                        <div className="card-body">
                                          <div className="d-flex align-items-start gap-3 p-3 rounded">
                                            <div className="detail-icon fs-5">
                                              <i className=" bx bx-location-plus font-24"></i>
                                            </div>
                                            <div className="detail-info">
                                              <h6 className="fw-bold mb-2">
                                                Address
                                              </h6>
                                              <p className="mb-0">
                                                {isSelectedData.addressLine1},{" "}
                                                {isSelectedData.addressLine2},{" "}
                                                {isSelectedData?.state},{" "}
                                                {isSelectedData?.district},{" "}
                                                {isSelectedData?.country} -{" "}
                                                {isSelectedData?.pincode}
                                              </p>
                                            </div>
                                          </div>
                                          <div className="d-flex align-items-start gap-3 p-3 rounded">
                                            <div className="detail-icon fs-5">
                                              <i className=" bx bx-comment-detail font-24"></i>
                                            </div>
                                            <div className="detail-info">
                                              <h6 className="fw-bold mb-1">
                                                Location Instruction
                                              </h6>
                                              <p className="mb-0">
                                                {
                                                  isSelectedData?.locationInstruction
                                                }
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    

                        <div className="card mb-0 ">
                          <div className="d-flex justify-content-between align-items-center box-header bg-light-theme p-2">
                            <h6 className="modal-title bg-light-theme-text ">
                              Payment
                            </h6>
                            <div className="view-actions">
                              <Tooltip
                                title="View Payment History"
                                arrow
                                PopperProps={{
                                  modifiers: [
                                    {
                                      name: "preventOverflow",
                                      options: {
                                        boundary: "window",
                                      },
                                    },
                                  ],
                                }}
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "white",
                                      color: "black",
                                      border: "1px solid black",
                                      fontSize: "12px",
                                      boxShadow:
                                        "0px 0px 5px rgba(0, 0, 0, 0.2)",
                                    },
                                  },
                                  arrow: {
                                    sx: {
                                      color: "white",
                                      borderBottom: "1px solid black",
                                    },
                                  },
                                }}
                              >
                                {" "}
                                <button
                                  type="button"
                                  onClick={handleOpenPayment}
                                >
                                  <i className="lni lni-eye me-2"></i>{" "}
                                  <span className="font-14">View</span>
                                </button>
                              </Tooltip>
                            </div>
                          </div>
                          <div className="card-body p-2">                                                    
                            <div
                              className="product-card"
                              style={{
                                backgroundColor:
                                  isSelectedData?.paymentStatus === "PAID"
                                    ? "#ddfde0"
                                    : isSelectedData?.paymentStatus === "UNPAID"
                                    ? "rgba(13, 110, 253, 0.11)"
                                    : "#f5f5f5",
                                borderRadius: "8px",
                              }}
                            >
                              <div className="p-2">
                                {isSelectedData?.bookingStatus === "ACCEPTED" && (
  <>
                                <div className="d-flex justify-content-between">
                                  <h6 className="payment text-muted   mb-2 me-2">
                                    Number of Acres:
                                    <span className="font-16 fw-bold text-dark ms-2">
                                      {isSelectedData?.numberOfAcres || 0} acres
                                    </span>
                                  </h6>
                                
                                  <div className="">
                                    {/* {(isSelectedData?.lastStatus === "ACCEPTED" && isSelectedData?.balanceAmount > 0) && (
                                    <button class="btn btn-sm btn-primary" onClick={(e) => {
                                      e.stopPropagation();
                                      handleOpen();
                                    }}>
                                      <i class="bx bx-plus me-1"/>Add Payment
                                      </button>
                                    )} */}
                                    {/* <span
                                      className={`badge ${
                                        isSelectedData?.paymentStatus === "PAID"
                                          ? "bg-label-paid"
                                          : isSelectedData?.paymentStatus ===
                                            "UNPAID"
                                          ? "bg-label-un-paid"
                                          : "bg-label-secondary"
                                      }`}
                                      style={{ marginLeft: "5px" }}
                                    >
                                      {isSelectedData?.paymentStatus ===
                                      "UNPAID"
                                        ? "UnPaid"
                                        : isSelectedData?.paymentStatus ===
                                          "PAID"
                                        ? "Paid"
                                        : isSelectedData?.paymentStatus}
                                    </span> */}
                                  </div>
                                </div>
                             {!isSelectedData?.supportsSplit && (isSelectedData?.lastStatus === "PLACED" ||isSelectedData?.bookingStatus === "ACCEPTED" ) &&(
                          <div className="d-flex align-items-center mb-2 mt-1">
                                
                                  <div className="row me-1">
                                    <div className="col-12 ">
                                      <input
                                        type="number"
                                        value={isEditableNmberOfAcres}
                                        onChange={(e) =>{
                                          setErrors("");
                                          setEditableNmberOfAcres(e.target.value)
                                        }}
                                        className="form-control form-control-lg me-3"
                                        style={{
                                          fontWeight: "600",
                                          minWidth: "120px",
                                        }}
                                        aria-label="Editable Total Amount"
                                      />
                                              {errors.numberOfAcres && (
                              <div className="invalid-feedback d-block mt-1">
                                {errors.numberOfAcres}
                              </div>
                            )}
                                    </div>
                             
                                  </div>

                                  <Tooltip title="Update No of Acres" arrow>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm px-3"
                                      onClick={handleUpdateAcres}
                                        disabled={
                                        loading.upadteBooking ||
                                        parseFloat(isEditableNmberOfAcres) === parseFloat(isSelectedData?.numberOfAcres)
                                      }                                  
                                    >
                                      {loading.upadteNoOfAcres ? (
                                        <CircularProgress
                                          size={18}
                                          color="inherit"
                                        />
                                      ) : (
                                        <>
                                          <i className="bx bx-save me-1"></i>{" "}
                                          Save
                                        </>
                                      )}
                                    </button>
                                  </Tooltip>
                                </div>  
                                )}
                                <div className="mb-2">
                                  <h6 className=" mb-1 text-muted">
                                    Price:{" "}
                                    <span className="font-16 fw-bold text-dark ms-2">
                                      ₹{isSelectedData?.perAcreCost || 0} Per
                                      Acre
                                    </span>
                                  </h6>
                                </div>  
                                {!isSelectedData?.supportsSplit && ( isSelectedData?.lastStatus === "PLACED" ||isSelectedData?.bookingStatus === "ACCEPTED") &&(
                          <div className="d-flex align-items-center mt-2">
                                  <span className="h4 fw-bold me-2 mb-0">
                                    ₹
                                  </span>
                                  <div className="row me-1">
                                    <div className="col-12 ">
                                      <input
                                        type="number"
                                        value={isEditablePerAcres}
                                        onChange={(e) =>{
                                            setErrors("");
                                          setEditablePerAcres(e.target.value)
                                        }}
                                        className="form-control form-control-lg me-3"
                                        style={{
                                          fontWeight: "600",
                                          minWidth: "120px",
                                        }}
                                        aria-label="Editable Total Amount"
                                      />
                                  {errors.perAcreCost && (
                              <div className="invalid-feedback d-block mt-1">
                                {errors.perAcreCost}
                              </div>
                            )}
                                    </div>
                         
                                  </div>

                                  <Tooltip title="Update price" arrow>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm px-3"
                                      onClick={handleUpdateAmount}
                                        disabled={
                                        loading.upadteBooking ||
                                        parseFloat(isEditablePerAcres) === parseFloat(isSelectedData?.perAcreCost)
                                      }                                  
                                    >
                                      {loading.upadteBooking ? (
                                        <CircularProgress
                                          size={18}
                                          color="inherit"
                                        />
                                      ) : (
                                        <>
                                          <i className="bx bx-save me-1"></i>{" "}
                                          Save
                                        </>
                                      )}
                                    </button>
                                  </Tooltip>
                                </div>  
                                 )}
                                 </>
                                )} 
                                 
                                <div
                                  className="mt-2 bg-white"
                                  style={{
                                    border: "1px solid #ddd",
                                    borderLeft: "5px solid #1a73e8",
                                    borderRadius: "8px",
                                    padding: "14px",
                                  }}
                                >
                                  <h6
                                    className="fw-bold text-blue"
                                    style={{ color: "#1a73e8" }}
                                  >
                                    Financial Overview
                                  </h6>
                                  
                                  <div className="row mt-3 g-0">
                                    <div className="col-4 text-center">
                                      <p className="text-muted mb-1 font-16">
                                        Total 
                                      </p>
                                      <h5 className=" text-green fw-bold mb-0">
                                        ₹{isSelectedData?.totalAmount}
                                      </h5>
                                    </div>
                                    <div className="col-4 text-center">
                                      <p className="text-muted mb-1 font-16">
                                         Paid
                                      </p>
                                      <h5 className="text-green fw-bold mb-0">
                                        ₹{isSelectedData?.totalPaid}
                                      </h5>
                                    </div>                                
                                    <div className="col-4 text-center">
                                      <p className="text-muted mb-1 font-16">
                                        Balance
                                      </p>
                                      <h5
                                        className="fw-bold mb-0"
                                        style={{
                                          color:
                                            isSelectedData?.balanceAmount > 0
                                              ? "red"
                                              : "green",
                                        }}
                                      >
                                        ₹{isSelectedData?.balanceAmount}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {isSelectedData?.workStatus === "COMPLETED" &&
                          (isSelectedData?.rating || isSelectedData?.review) && (
  
                         <div className="card mt-3 mb-2">
                        <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center py-3">
                          <div>
                            <h6 className="mb-0 fw-bold text-primary">
                              <i className="lni lni-star-filled text-warning me-2"></i>
                              Rating & Review
                            </h6>
                            <small className="text-muted">
                          
                            </small>
                          </div>

                          <div className="d-flex align-items-center">
                            {[1, 2, 3, 4, 5].map((star) => (
                              <i
                                key={star}
                                className={`lni lni-star-filled fs-5 me-1 ${
                                  star <= (isSelectedData?.rating || 0)
                                    ? "text-warning"
                                    : "text-secondary opacity-25"
                                }`}
                              />
                            ))}

                            <span className="badge bg-warning text-dark ms-2">
                              {isSelectedData?.rating}/5
                            </span>
                          </div>
                        </div>

                        <div className="card-body">
                          <div
                            className="p-3 rounded"
                            style={{
                              background: "#f8f9fa",
                              borderLeft: "4px solid #ffc107",
                            }}
                          >
                            <i className="lni lni-quotation text-warning me-2"></i>

                            <span
                              className="text-muted fst-italic"
                              style={{ fontSize: "15px", lineHeight: "1.7" }}
                            >
                              {isSelectedData?.review || "No review provided."}
                            </span>
                          </div>

                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <small className="text-muted">
                              <i className="lni lni-user me-1"></i>
                              Reviewed by{" "}
                              <strong className="text-dark">
                                {isSelectedData?.lastUpdatedBy}
                              </strong>
                            </small>

                            {isSelectedData?.updatedAt && (
                              <small className="text-muted">
                                {new Date(isSelectedData.updatedAt).toLocaleDateString()}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    
                    {activeView === "status" && (
                      <div className="card mb-0 mt-0 scroll-container">
                        <div
                        style={{
                          position: "sticky",
                          top: "0",
                          zIndex: "10",
                          background: "#fff",
                        }}
                      >
                        
                          <div className="d-flex justify-content-between align-items-center box-header bg-light-theme p-2 rounded-start-0  rounded-end-0">
                            <h6 className="modal-title bg-light-theme-text  ">
                              Booking Status
                            </h6>
                            <div className="view-actions">
                              {loading?.viewBooking ? (
                                                     <button className="btn btn-primary btn-sm d-flex align-items-center" disabled>
                                                       <CircularProgress size={16} className="text-white " /> 
                                                     </button>
                                                   ) : (
                                <button type="button"   onClick={(e) => {
                                  e.stopPropagation();
                                handleViewBooking(isSelectedData);
                                }}>
                                  <i className="bx bx-refresh me-2"></i>{" "}
                                  <span className="font-14">Refresh</span>
                                </button>
                                                   )}
    
                            </div>
                          </div>
                      
                      </div>
                        {/* <div
                          style={{
                            position: "sticky",
                            top: "0",
                            zIndex: "10",
                            background: "#fff",
                          }}
                        >
                             <div className="d-flex justify-content-between align-items-center box-header bg-light-theme p-2 rounded-start-0  rounded-end-0">
                          <button
                            className="accordion-button rounded-end-0 rounded-start-0"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="true"
                            aria-controls="flush-collapseOne"
                          >
                            Booking Status
                          </button>
                          </div>
                        </div> */}
                        <div className="card-body pt-3 pb-1">
      
                          {/* { ( isSelectedData?.bookingStatus === 'ACCEPTED' && !(
                        isSelectedData?.bookingStatusHistory?.some(history => 
                          history.bookingTracking === 'PAYMENT'
                        ))) && 
                       isSelectedData?.totalPaid === 0 &&( */}
                       {isSelectedData?.bookingStatus !== "CANCELLED" && (
                          <div className="d-flex justify-content-end mb-3">
                               <button 
                            className={`btn ${
                                isSelectedData?.workStatus === "COMPLETED" || isSelectedData?.workStatus === "STARTED" || isSelectedData?.lastStatus === "BOOKINGCONFIRMED" ||
                                  isSelectedData?.bookingStatusHistory?.some(
                                    (history) => history.bookingTracking === "BOOKINGCONFIRMED"
                                  )
                                  ? "btn-secondary" 
                                  : "btn-danger"
                              }`}
                             onClick={handleOpenCancelBooking}
                             disabled={isSelectedData?.workStatus === "COMPLETED" || isSelectedData?.workStatus === "STARTED" || isSelectedData?.lastStatus === "BOOKINGCONFIRMED" ||
                            isSelectedData?.bookingStatusHistory?.some(
                              (history) => history.bookingTracking === "BOOKINGCONFIRMED"
                            )}
                          
                          >
                            Cancel Booking
                          </button>                       
                        
                          </div> 
                          )}                   
                     

                                    {isSelectedData?.isPrimaryBooking === false ? (
  <div className="p-2">
    <div className="alert alert-info d-flex align-items-start gap-2" role="alert">
      <i className="bx bx-info-circle fs-5"></i>
      <div>
        This is one part of Booking #{parentBookingSummary?.bookingNumber || isSelectedData?.parentBookingId}
        {isSelectedData?.assignedTo?.fullName && (
          <> — assigned to Captain <strong>{capitalizeFirstLetter(isSelectedData.assignedTo.fullName)}</strong></>
        )}
      </div>
    </div>

    <div className="border radius-10 p-2 mb-3">
      <h6 className="fw-bold text-muted mb-1 font-13">Current Status</h6>
      <p className="mb-0 fw-bold text-dark">{getSubBookingStatusLabel(isSelectedData?.lastStatus)}</p>
    </div>

    {isSelectedData?.parentBookingId && (
      <button
        type="button"
        className="btn btn-sm btn-label-navy"
        onClick={() => handleViewBooking({ _id: isSelectedData.parentBookingId })}
      >
        <i className="bx bx-arrow-back me-1"></i> View Primary Booking
      </button>
    )}
  </div>
) : (
  <AdminBookingTimeline
  isSelectedData={isSelectedData}
  loading={loading}
  measurement={measurement}
  setMeasurement={setMeasurement}

  // Pass down all the click handlers used by the action blocks:
  onApprove={onApprove}
  handleBookingConfirm={handleBookingConfirm}
  handleOpenFOAssessment={handleOpenFOAssessment}
  handleSaveMeasurement={handleSaveMeasurement}
  handleUploadImages={handleUploadImages}

  // If you want to retain your specific validation checks from your state:
  isSameMeasurement={isSameMeasurement}
  setShowAssignOptions={setShowAssignOptions}
  setAssignModal={setAssignModal}
  handleUploadWorkImages={handleUploadWorkImages}

setShowCompleteModal={setShowCompleteModal}
canCompleteBooking={canCompleteBooking}
isSplitWorkCompleted={isSplitWorkCompleted}
/>
)}
                     
                     
                     
                       </div>
                      </div>
                    )}
 
                    {activeView === "payment" && (
                      <PaymentHistory
                        isPayment={isPayment}
                        setPayment={setPayment}
                        handleClose={handleClose}
                        isSelectedData={isSelectedData}
                        setSelectedData={setSelectedData}
                        setBooking={setBooking}
                        handleOpen={handleOpen}
                        loading={loading}
                      />
                    )}
                    {openFOAssessment &&(
                     <>   


                    <div className="modal-backdrop show"></div>
                    <div
                      className="modal show d-block"
                      id="ViewPartnerModal"
                      tabIndex="-1"
                      aria-modal="true"
                      role="dialog"
                    >
                      <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content ">           
                          <div className="modal-header border-bottom-0 py-3">
                            <h6 className="modal-title fw-semibold">
                              Update Field Officer Assessment                
                            </h6>
                            <button
                              type="button"
                              className="btn-close border"
                              onClick={onClose}
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">

                            {/* Farmer Optional */}
                            <div className="mb-3">
                              <label className="form-label fw-semibold">Credibility of the Farmer</label> <span className="text-blue ms-1">(Optional)</span>
                              <div className="d-flex gap-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="credibility"
                                    value="yes"
                                    checked={formData.credibility === "yes"}
                                    onChange={handleChange}
                                  />
                                    <label className="form-check-label">Yes</label>
                                </div>

                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="credibility"
                                    value="no"
                                    checked={formData.credibility === "no"}
                                    onChange={handleChange}
                                  />
                                  <label className="form-check-label">No</label>
                                </div>
                              </div>
                            </div>

                            {/* Farmer Name */}
                            <div className="mb-3">
                            <label className="form-label fw-semibold">
                                      Farmer Name  <span className="text-danger ms-1">*</span>
                                    </label>

                            <input
                                        type="text"
                                        ref={nameRef}
                                        className="form-control"
                                        name="name"
                                        placeholder=""
                                        value={formData.name}
                                        onKeyDown={(e) => handleEnterKey(e, phoneRef)}
                                        onChange={handleChange}
                                      />
                                      {errors.name && (
                                        <div className="error-message invalid-feedback">
                                          {errors.name}
                                        </div>
                                      )}
                            </div>

                            {/* Farmer Number */}
                            <div className="mb-3">
                              <label className="form-label fw-semibold">Farmer Number</label> <span className="text-danger ms-1">*</span>
                            <input
                                        type="text"
                                        ref={phoneRef}
                                        className="form-control"
                                        name="mobileNumber"
                                        placeholder=""
                                        value={formData.mobileNumber}
                                        maxLength={10}
                                        onChange={handleChange}
                                      
                                        onKeyDown={(e) => handleEnterKey(e, DimensionRef)}
                                        
                                      />
                                      {errors.phone && (
                                        <div className="error-message invalid-feedback">
                                          {errors.phone}
                                        </div>
                                      )}
                            </div>
                          
                            <div className="mb-3 ">
                              <label className="form-label fw-semibold">Dimension</label> <span className="text-danger ms-1">*</span>
                              <select
                            className="form-select"
                            ref={DimensionRef}
                            value={selectedDimension}
                              onKeyDown={(e) =>
                                          handleEnterKey(e, saveButtonRef, true)
                                        }
                            style={{ textTransform: "capitalize" }}
                            onChange={(e) => setSelectedDimension(e.target.value)}
                          >
                                <option value={isSelectedData?.perAcreCost}>Current - ₹{isSelectedData?.perAcreCost}</option>

                            {dimensionList?.map((item, index) => (
                              <option key={index} value={item.dimension}  style={{ textTransform: "capitalize" }}>
                              <span >  {item.dimension} - ₹{item.amount}
                            </span> </option>
                            ))}
                          </select>
                            </div>

                            {/* Stones */}
                            <div className="mb-3">
                              <label className="form-label fw-semibold">Stones</label> <span className="text-blue ms-1">(Optional)</span>
                              <div className="d-flex gap-3">
                                <div className="form-check">
                                  <input className="form-check-input" type="radio" name="stones" value="YES" checked={formData.stones === "YES"} onChange={handleChange} />
                                  <label className="form-check-label">Yes</label>
                                </div>
                                <div className="form-check">
                                  <input className="form-check-input" type="radio" name="stones" value="NO" checked={formData.stones === "NO"} onChange={handleChange} />
                                  <label className="form-check-label">No</label>
                                </div>
                                <div className="form-check">
                                  <input className="form-check-input" type="radio" name="stones" value="MAYBE" checked={formData.stones === "MAYBE"} onChange={handleChange} />
                                  <label className="form-check-label">Maybe</label>
                                </div>
                              </div>
                            </div>

                            {/* Nursery Date */}
                            <div className="mb-3">
                              <label className="form-label fw-semibold">Nursery Date</label> <span className="text-blue ms-1">(Optional)</span>
                              <input
                                type="date"
                                className="form-control"
                                name="nurseryDate"
                                value={formData.nurseryDate}
                                max={todayIsoDate()}
                                onChange={handleChange}
                              />
                            </div>

                            {/* Nursery Field */}
                            <div className="mb-3">
                              <label className="form-label fw-semibold">Nursery Field</label> <span className="text-blue ms-1">(Optional)</span>
                              <div className="d-flex gap-3">
                                <div className="form-check">
                                  <input className="form-check-input" type="radio" name="nurseryField" value="SOFT" checked={formData.nurseryField === "SOFT"} onChange={handleChange} />
                                  <label className="form-check-label">Soft</label>
                                </div>
                                <div className="form-check">
                                  <input className="form-check-input" type="radio" name="nurseryField" value="HARD" checked={formData.nurseryField === "HARD"} onChange={handleChange} />
                                  <label className="form-check-label">Hard</label>
                                </div>
                              </div>
                            </div>

                            {/* Nursery Distance */}
                            <div className="mb-3">
                              <label className="form-label fw-semibold">Nursery Distance to Field</label> <span className="text-blue ms-1">(Optional)</span>
                              <select
                                className="form-select"
                                name="nurseryDistance"
                                value={formData.nurseryDistance}
                                onChange={handleChange}
                              >
                                <option value="">Select</option>
                                {Object.entries(NURSERY_DISTANCE_LABELS).map(([value, label]) => (
                                  <option key={value} value={value}>{label}</option>
                                ))}
                              </select>
                            </div>

                            {/* Accommodation Photos */}
                            <div className="mb-3">
                              <label className="form-label fw-semibold">Accommodation Front Photo</label> <span className="text-blue ms-1">(Optional)</span>
                              <input
                                type="file"
                                accept="image/*"
                                className="form-control"
                                onChange={(e) =>
                                  setFormData((prev) => ({ ...prev, accommodationFrontPhoto: e.target.files[0] || null }))
                                }
                              />
                            </div>
                            <div className="mb-3">
                              <label className="form-label fw-semibold">Accommodation Inside Photo</label> <span className="text-blue ms-1">(Optional)</span>
                              <input
                                type="file"
                                accept="image/*"
                                className="form-control"
                                onChange={(e) =>
                                  setFormData((prev) => ({ ...prev, accommodationInsidePhoto: e.target.files[0] || null }))
                                }
                              />
                            </div>

                            {/* Water / Fan Availability */}
                            <div className="mb-3">
                              <label className="form-label fw-semibold">Water Availability</label> <span className="text-blue ms-1">(Optional)</span>
                              <div className="d-flex gap-3">
                                <div className="form-check">
                                  <input className="form-check-input" type="radio" name="waterAvailable" value="true" checked={formData.waterAvailable === "true"} onChange={handleChange} />
                                  <label className="form-check-label">Yes</label>
                                </div>
                                <div className="form-check">
                                  <input className="form-check-input" type="radio" name="waterAvailable" value="false" checked={formData.waterAvailable === "false"} onChange={handleChange} />
                                  <label className="form-check-label">No</label>
                                </div>
                              </div>
                            </div>
                            <div className="mb-3">
                              <label className="form-label fw-semibold">Fan Availability</label> <span className="text-blue ms-1">(Optional)</span>
                              <div className="d-flex gap-3">
                                <div className="form-check">
                                  <input className="form-check-input" type="radio" name="fanAvailable" value="true" checked={formData.fanAvailable === "true"} onChange={handleChange} />
                                  <label className="form-check-label">Yes</label>
                                </div>
                                <div className="form-check">
                                  <input className="form-check-input" type="radio" name="fanAvailable" value="false" checked={formData.fanAvailable === "false"} onChange={handleChange} />
                                  <label className="form-check-label">No</label>
                                </div>
                              </div>
                            </div>

                            {/* Stay to Field Distance */}
                            <div className="mb-3">
                              <label className="form-label fw-semibold">Stay to Field Distance (km)</label> <span className="text-blue ms-1">(Optional)</span>
                              <input
                                type="number"
                                className="form-control"
                                name="stayToFieldDistanceInKm"
                                value={formData.stayToFieldDistanceInKm}
                                onChange={handleChange}
                              />
                            </div>

                            {/* Farmer Provides Vehicle */}
                            <div className="mb-3">
                              <label className="form-label fw-semibold">Farmer Provides Vehicle</label> <span className="text-blue ms-1">(Optional)</span>
                              <div className="d-flex gap-3">
                                <div className="form-check">
                                  <input className="form-check-input" type="radio" name="farmerProvidesVehicle" value="true" checked={formData.farmerProvidesVehicle === "true"} onChange={handleChange} />
                                  <label className="form-check-label">Yes</label>
                                </div>
                                <div className="form-check">
                                  <input className="form-check-input" type="radio" name="farmerProvidesVehicle" value="false" checked={formData.farmerProvidesVehicle === "false"} onChange={handleChange} />
                                  <label className="form-check-label">No</label>
                                </div>
                              </div>
                            </div>

                          </div>
                          <div className="modal-footer d-flext justify-content-between  border-0 pt-0">
                            <button
                              type="button"
                              className="btn btn-outline-secondary px-3"
                              onClick={onClose}
                            >
                              Close
                            </button>
                            {loading.foAssessment ? (
                                          <button className="btn btn-primary pb-0 text-right" disabled>
                                            <CircularProgress size={22} className="text-white" />
                                          </button>
                                        ) : (
                              <button
                                type="button"
                                className="btn btn-primary px-3"  
                                  onClick={handleAdd} 
                                  disabled={
                                !formData.name &&
                                !formData.mobileNumber &&
                                formData.credibility === "" &&
                                !isDimensionChanged &&
                                !hasNewAssessmentData
                              }
                              >                
                                  <>
                                    <i className="bx bx-check"></i> Submit
                                  </>
                            
                              </button>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                    )}
                  </div>
                </div>
           
              </div>
            </div>
           
              {/* <div className="modal-footer border-top-0 py-3 d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-outline-secondary px-3"
                onClick={onClose}
              >
                Close
              </button>
               
              </div> */}
                 {showCancelModal && (
                  <CancelBooking onClose={handleCloseCancelBooking} loading={loading} cancelBooking={confirmCancelBooking} isSelectedData={isSelectedData}/>
                )}
                  {isOpen && (
                  <PaymentForm onClose={isModelClose} loading={loading} AddPayment={AddPayment} isSelectedData={isSelectedData}/>
                )}
                {assignModal.gangLeader && (
                  <AssignGangLeader onClose={handleCloseAssign} name="Assign Captain"  setBooking={setBooking}
                   loading={loading}  isSelectedData={isSelectedData} setLoading={setLoading} setSelectedData={setSelectedData}/>
                )}
                 {assignModal.fieldOfficer && (
                  <AssignFieldOfficer onClose={handleCloseAssign} name="Assign Field Officer"  setBooking={setBooking}
                   loading={loading}  isSelectedData={isSelectedData} setLoading={setLoading} setSelectedData={setSelectedData}/>
                )}
                {assignModal.gangLeaderBatch && (
                  <AssignGangLeaderBatch
                    onClose={handleCloseAssignBatch}
                    bookingId={isSelectedData?._id}
                    pincode={isSelectedData?.pincode}
                    numberOfAcres={isSelectedData?.numberOfAcres}
                  />
                )}

                {openMeasurementModal && (
  <>
    <div className="modal-backdrop show"></div>

    <div
      className="modal show d-block"
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          {/* Header */}
          <div className="modal-header border-0">
            <h6 className="modal-title fw-semibold">
              Edit Measurement
            </h6>

            <button
              type="button"
              className="btn-close"
              onClick={handleCloseMeasurementModal}
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body pt-3">

            <label className="form-label fw-semibold">
              Measurement (Acre)
            </label>

            <input
              type="number"
              className="form-control"
              value={measurement}
              onChange={(e) => {
                let val = e.target.value;

                // allow empty
                if (val === "") {
                  setMeasurement("");
                  return;
                }

                // allow only 1 decimal place
                if (/^\d+(\.\d{0,1})?$/.test(val)) {
                  setMeasurement(val);
                }
              }}
              step="0.1"
              min="0"
            />                

          </div>

          {/* Footer */}
          <div className="d-flex justify-content-between modal-footer border-0">

            <button
              className="btn btn-outline-secondary"
              onClick={handleCloseMeasurementModal}
            >
              Cancel
            </button>

            <button
              className="btn btn-primary"
              onClick={handleSaveMeasurement}
            >
              Save Changes
            </button>

          </div>

        </div>
      </div>
    </div>
  </>
)}
{openWorkImageModal && (
  <>
    <div className="modal-backdrop show"></div>

    <div
      className="modal show d-block"
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          {/* Header */}
          <div className="modal-header border-0">
            <h6 className="modal-title fw-semibold">
              Upload Work Images
            </h6>

            <button
              type="button"
              className="btn-close"
              onClick={handleCloseUploadWorkImages}
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body">
            <div className="card w-100 radius-10 mb-0 shadow-none p-3">
              <div className="card-body p-0">

                <div className="row g-3">

                  <div className="col-lg-12">
                    <label className="form-label">
                      Choose Images <span className="text-blue">(Max 3 Images)</span>
                    </label>

                    <input
                      type="file"
                      multiple
                      ref={WorkImagesRef}
                      accept="image/jpeg,image/png,image/jpg"
                      className={`form-control ${errors.workImages ? "is-invalid" : ""}`}
                      onChange={handleImageChange}
                    />

                    {/* <small className="text-muted">
                      Allowed: JPG, JPEG, PNG (Max 3 Images)
                    </small> */}

                    {errors.workImages && (
                      <div className="invalid-feedback d-block">
                        {errors.workImages}
                      </div>
                    )}
                  </div>

                  {/* Preview Images */}
                  {formData.workImagePreviews?.length > 0 && (
                    <div className="col-lg-12">
                      <div className="d-flex flex-wrap gap-3 mt-2">

                        {formData.workImagePreviews.map((img, index) => (
                          <div key={index} className="position-relative">

                            <img
                              src={img}
                              alt={`preview-${index}`}
                              className="reviewPreview"
                            />

                            <button
                              type="button"
                              className="btn btn-danger btn-sm position-absolute top-0 end-0 rounded-circle"
                              style={{
                                width: "22px",
                                height: "22px",
                                padding: "0",
                                fontSize: "12px",
                              }}
                              onClick={() => handleRemoveImage(index)}
                            >
                              ×
                            </button>

                          </div>
                        ))}

                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="d-flex justify-content-between modal-footer border-0">

            <button
              className="btn btn-outline-secondary"
              onClick={handleCloseUploadWorkImages}
            >
              Close
            </button>
 {loading.workImage ? (
                           <button className="btn btn-primary pb-0 text-right" disabled>
                             <CircularProgress size={22} className="text-white" />
                              </button>
                           ) : (
            <button
              className="btn btn-primary"
              onClick={handleSaveUploadImages}
            >
              <i className="bx bx-check"></i>
              Update images
            </button>
                           )}
          </div>

        </div>
      </div>
    </div>
  </>
)}
{showCompleteModal && (
   <>
    <div className="modal-backdrop show"></div>
    <div
      className="modal show d-block"
      tabIndex="-1"
      role="dialog"
    >
        <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        
        {/* Modal Header */}
         <div className="modal-header border-0">
          <h6 className="modal-title  fw-semibold"> Booking Verification</h6>
          <button 
            type="button" 
            className="btn-close" 
            onClick={() => setShowCompleteModal(false)}
          ></button>
        </div>
  
        {/* Modal Body / Checklist */}
        <div className="modal-body">
          <p className="text-muted mb-3">Please confirm that all the required tasks are completed:</p>

          {isSelectedData?.supportsSplit ? (
            loadingCompleteModalSubBookings ? (
              <div className="text-center py-3"><CircularProgress size={22} /></div>
            ) : (
              <ul className="list-group list-group-flush">
                {completeModalSubBookings
                  .filter((sb) => sb.lastStatus !== "CANCELLED")
                  .map((sb) => {
                    const allocation = (isSelectedData?.glAllocations || []).find(
                      (a) => a.subBookingId === sb._id
                    );
                    const glName = capitalizeFirstLetter(allocation?.gangleaderName) || "-";
                    return (
                      <li key={sb._id} className="list-group-item py-3">
                        <div className="fw-bold mb-1">{glName}</div>
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <i className={`bx ${sb.isGlMeasurementAccepted ? "bx-check-circle text-success" : "bx-time-five text-muted"} fs-5`}></i>
                          <span className={sb.isGlMeasurementAccepted ? "" : "text-muted"}>Measurement Accepted</span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <i className={`bx ${sb.isGlWorkCompleted ? "bx-check-circle text-success" : "bx-time-five text-muted"} fs-5`}></i>
                          <span className={sb.isGlWorkCompleted ? "" : "text-muted"}>Work Completed</span>
                        </div>
                      </li>
                    );
                  })}
                <li className="list-group-item d-flex align-items-center gap-2 py-3">
                  <i className={`bx ${Number(isSelectedData?.balanceAmount || 0) <= 0 ? "bx-check-circle text-success" : "bx-time-five text-muted"} fs-4`}></i>
                  <div>
                    <strong className={Number(isSelectedData?.balanceAmount || 0) <= 0 ? "" : "text-muted"}>Payment Completed</strong>
                  </div>
                </li>
              </ul>
            )
          ) : (
          <ul className="list-group list-group-flush">
             <li className="list-group-item d-flex align-items-center gap-2 py-3">
              <i className="bx bx-check-circle text-success fs-4"></i>
              <div>
                <strong>Measurement Accepted</strong>
              </div>
            </li>
            <li className="list-group-item d-flex align-items-center gap-2 py-3">
              <i className="bx bx-check-circle text-success fs-4"></i>
              <div>
                <strong>Work Completed</strong>
              </div>
            </li>
              <li className="list-group-item d-flex align-items-center gap-2 py-3">
              <i className="bx bx-check-circle text-success fs-4"></i>
              <div>
                <strong>GEO Image Uploaded</strong>
              </div>
            </li>
            <li className="list-group-item d-flex align-items-center gap-2 py-3">
              <i className="bx bx-check-circle text-success fs-4"></i>
              <div>
                <strong>Payment Completed</strong>
              </div>
            </li>


          </ul>
          )}
        </div>

        {/* Modal Footer / Actions */}
         <div className="d-flex justify-content-between modal-footer border-0">
          <button 
            type="button" 
             className="btn btn-outline-secondary"
            onClick={() => setShowCompleteModal(false)}
          >
            Cancel
          </button>
          {loading.bookingComplete ? (
                              <button
                                className="btn btn-primary pb-0 text-right"
                                disabled
                              >
                                <CircularProgress
                                  size={22}
                                  className="text-white"
                                />
                                   </button>):(
          <button 
            type="button" 
             className="btn btn-primary" 
           onClick={handleBookingComplete}
          >
            Confirm & Submit
          </button>
          )}
        </div>

      </div>
    </div>
  </div>
  </>
)}
{/* sinfgle */}
 {/* {openImageModal && (
  <>
    <div className="modal-backdrop show"></div>

    <div
      className="modal show d-block"
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

       
          <div className="modal-header border-0">
            <h6 className="modal-title fw-semibold">
              Upload Image
            </h6>

            <button
              type="button"
              className="btn-close"
              onClick={handleCloseUploadImages}
            ></button>
          </div>

      
        <div className="modal-body">
  <div className="card w-100 radius-10 mb-0 shadow-none p-3">
    <div className="card-body p-0">

      <div className="row g-3">

     
        <div className="col-lg-12">
          <label className="form-label">
            Upload Final Work Image
          </label>

          <input
            type="file"
            accept="image/jpeg,image/png,image/jpg"
            className={`form-control ${
              errors.finalImage ? "is-invalid" : ""
            }`}
            onChange={handleFinalImageChange}
          />

          {errors.finalImage && (
            <div className="invalid-feedback d-block">
              {errors.finalImage}
            </div>
          )}
        </div>

   
        {formData.finalImagePreview && (
          <div className="col-lg-12">
            <img
              src={formData.finalImagePreview}
              alt="preview"
              style={{
                width: "120px",
                height: "120px",
                objectFit: "cover",
                borderRadius: "10px",
                border: "1px solid #ddd"
              }}
            />
          </div>
        )}


        <div className="col-lg-6">
          <label className="form-label">
            Latitude
          </label>

          <input
            type="number"
            className={`form-control ${
              errors.latitude ? "is-invalid" : ""
            }`}
            placeholder="Enter latitude"
            value={formData.latitude}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                latitude: e.target.value
              }))
            }
          />

          {errors.latitude && (
            <div className="invalid-feedback d-block">
              {errors.latitude}
            </div>
          )}
        </div>

   
        <div className="col-lg-6">
          <label className="form-label">
            Longitude
          </label>

          <input
            type="number"
            className={`form-control ${
              errors.longitude ? "is-invalid" : ""
            }`}
            placeholder="Enter longitude"
            value={formData.longitude}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                longitude: e.target.value
              }))
            }
          />

          {errors.longitude && (
            <div className="invalid-feedback d-block">
              {errors.longitude}
            </div>
          )}
        </div>

      </div>
    </div>
  </div>
</div>

        
          <div className="d-flex justify-content-between modal-footer border-0">

            <button
              className="btn btn-outline-secondary"
              onClick={handleCloseUploadImages}
            >
              Close
            </button>

            <button
              className="btn btn-primary"
              onClick={handleUploadFinalImages}
            >
              <i className="bx bx-check"></i>
              Update
            </button>

          </div>

        </div>
      </div>
    </div>
  </>
)}  */}
{openImageModal && (
        <UploadWorkModal 
          openImageModal={openImageModal}
          isSelectedData={isSelectedData}
          setSelectedData={setSelectedData}
          handleCloseUploadImages={handleCloseUploadImages}
          showAlert={showAlert}
          loading={loading}
        />
      )}

          </div>
        </div>
      </div>
    </div>
  );
};

Viewbooking.propTypes = {
  onClose: PropTypes.func,
  isSelectedData: PropTypes.object,
};

export default Viewbooking;
  


